require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/a31967cfcdfc3278762b05fe92b4fc2f/code.js', () => { 

var surah_list, aya, item, student_aya, surah, pagelist, first_aya;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



BackendlessUI.Functions.Custom['fn_a31967cfcdfc3278762b05fe92b4fc2f'] = async function fn_a31967cfcdfc3278762b05fe92b4fc2f(PageValue, student_id) {
    if (typeof PageValue === 'number') {
    pagelist = (await Backendless.Data.of('Aya').find(Backendless.DataQueryBuilder.create().setWhereClause((['Page[aya_link].page_number=\'',PageValue,'\''].join(''))).setProperties(['objectId', 'aya_text', 'aya_number_ar', 'aya_number_surah', 'Surah[aya_link].name as s_name', 'Surah[aya_link].surah_number', 'aya_number']).setSortBy(['aya_number']).setPageSize(100)));
    student_aya = (await Backendless.Data.of('Aya').find(Backendless.DataQueryBuilder.create().setWhereClause((['Page[aya_link].page_number=\'',PageValue,'\' and Student[aya_link].objectId=\'',student_id,'\''].join(''))).setProperties(['objectId']).setPageSize(100)));
    if (pagelist.length > 0) {
      surah_list = [];
      first_aya = pagelist.shift();
      if ((first_aya['aya_number_surah']) == 1) {
        addItemToList(surah_list, ({ 'surah_name': (first_aya['s_name']),'show': true,'aya': [({ 'objectId': (first_aya['objectId']),'text': (first_aya['aya_text']),'number_in_surah': (first_aya['aya_number_surah']),'aya_number_ar': (first_aya['aya_number_ar']),'aya_number': (first_aya['aya_number']),'class': (await (async () => {
          async function callback (item) {


            return ((first_aya['objectId']) == (item['objectId']));
          }

          const list = await Promise.all(student_aya.map(async source => ({
            source,
            value: await callback(source),
          })));

          const resultList = list.filter(item => item.value)

          return resultList.map(item => item.source)
        })()).length > 0 ? ['ALLREADYSAVED'] : [],'surah_number': (first_aya['surah_number']),'surah_name': (first_aya['s_name']) })] }));
      } else {
        addItemToList(surah_list, ({ 'surah_name': (first_aya['s_name']),'show': false,'aya': [({ 'objectId': (first_aya['objectId']),'text': (first_aya['aya_text']),'number_in_surah': (first_aya['aya_number_surah']),'aya_number_ar': (first_aya['aya_number_ar']),'aya_number': (first_aya['aya_number']),'class': (await (async () => {
          async function callback (item) {


            return ((first_aya['objectId']) == (item['objectId']));
          }

          const list = await Promise.all(student_aya.map(async source => ({
            source,
            value: await callback(source),
          })));

          const resultList = list.filter(item => item.value)

          return resultList.map(item => item.source)
        })()).length > 0 ? ['ALLREADYSAVED'] : [],'surah_number': (first_aya['surah_number']),'surah_name': (first_aya['s_name']) })] }));
      }
      for (var aya_index in pagelist) {
        aya = pagelist[aya_index];
        surah = (await (async () => {
          async function callback (item) {


            return ((item['surah_name']) == (aya['s_name']));
          }

          const list = await Promise.all(surah_list.map(async source => ({
            source,
            value: await callback(source),
          })));

          const resultList = list.filter(item => item.value)

          return resultList.map(item => item.source)
        })());
        if (1 == surah.length) {
          surah = surah[0];
          addItemToList((surah['aya']), ({ 'objectId': (aya['objectId']),'text': (aya['aya_text']),'number_in_surah': (aya['aya_number_surah']),'aya_number_ar': (aya['aya_number_ar']),'aya_number': (aya['aya_number']),'class': (await (async () => {
            async function callback (item) {


              return ((aya['objectId']) == (item['objectId']));
            }

            const list = await Promise.all(student_aya.map(async source => ({
              source,
              value: await callback(source),
            })));

            const resultList = list.filter(item => item.value)

            return resultList.map(item => item.source)
          })()).length > 0 ? ['ALLREADYSAVED'] : [],'surah_number': (aya['surah_number']),'surah_name': (aya['s_name']) }));
        } else if (0 == surah.length) {
          addItemToList(surah_list, ({ 'surah_name': (aya['s_name']),'show': true,'aya': [({ 'objectId': (aya['objectId']),'text': (aya['aya_text']),'number_in_surah': (aya['aya_number_surah']),'aya_number_ar': (aya['aya_number_ar']),'aya_number': (aya['aya_number']),'class': (await (async () => {
            async function callback (item) {


              return ((aya['objectId']) == (item['objectId']));
            }

            const list = await Promise.all(student_aya.map(async source => ({
              source,
              value: await callback(source),
            })));

            const resultList = list.filter(item => item.value)

            return resultList.map(item => item.source)
          })()).length > 0 ? ['ALLREADYSAVED'] : [],'surah_number': (aya['surah_number']),'surah_name': (aya['s_name']) })] }));
        }
      }
    }
  }


  return surah_list
}

})
define('./functions/e0a989849d6a5d22cb686c19de15e3b5/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5'] = function fn_e0a989849d6a5d22cb686c19de15e3b5(Number) {
return ((((((((((Number.replace((new RegExp('0', 'g')), '٠')).replace((new RegExp('1', 'g')), '١')).replace((new RegExp('2', 'g')), '٢')).replace((new RegExp('3', 'g')), '٣')).replace((new RegExp('4', 'g')), '٤')).replace((new RegExp('5', 'g')), '٥')).replace((new RegExp('6', 'g')), '٦')).replace((new RegExp('7', 'g')), '٧')).replace((new RegExp('8', 'g')), '٨')).replace((new RegExp('9', 'g')), '٩'))
}

})
define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/Login/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var user, error, password, username, stayLoggedIn, logging, buttonLogin;

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.UserService.login( username, password, stayLoggedIn  ));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}

/**
 * Describe this function...
 */
async function updateButtonLogin(logging) {
  buttonLogin = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  buttonLogin['label'] = (logging ? 'الرجاء الإنتظار....' : 'دخول');
  buttonLogin['disabled'] = logging;
}


  await setError(null);
  username = (___arguments.context.dataModel['username']);
  password = (___arguments.context.dataModel['password']);
  stayLoggedIn = (___arguments.context.dataModel['stayLoggedIn']);
  if (username && password) {
    await updateButtonLogin(true);
    try {
      await login();

    } catch (error) {
      if ((error['code']) == 3033) {
        await login();
      } else {
        await setError(error);
      }

    } finally {
      await updateButtonLogin(false);

    }
  } else {
    await setError((new Error('المستخدم وكلمة المرور مطلوبة.')));
  }
  if (user) {
    ___arguments.context.appData['currentUser'] = user;
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('landing', null);
  }

  },  
  /* handler:onSubmit *//* content */
}));

define('./pages/Login/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      await Backendless.UserService.logout()

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/Login/components/f8440789ca334b45ce69d2f5dfd3d906/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('dd5c653101c733a2cff71b650e6b215a'))['height'] = '0';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Login/components/116994740fa538677911ad55b1f1ff9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('dd5c653101c733a2cff71b650e6b215a'))['height'] = '100%';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/circle/components/f74a61674c7e734d4f9511232fbe2cd7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}


  if ((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['sex']) == 'بنين') {
    return (['اتم حفظ : ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']) <= 10 ? ' آيات ' : ' آيه ',listsGetRandomItem([' بارك الله فيه ', ' اثابه الله ', ' وفقه الله '], false)].join(''));
  } else {
    return (['اتمت حفظ : ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']) <= 10 ? ' آيات ' : ' آيه ',listsGetRandomItem([' بارك الله فيها ', ' اثابها الله', ' وفقها الله '], false)].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/circle/components/e352901a4747d17fcf57c288809c1f4e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var current_month;


  current_month = [(new Date((new Date())).getMonth()) + 1 >= 10 ? (new Date((new Date())).getMonth()) + 1 : String(0) + String((new Date((new Date())).getMonth()) + 1),'/01/',(new Date((new Date())).getFullYear())].join('');

  return (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['created_month >= \'',current_month,'\' AND ForStudent.circle_link.objectId=\'',(___arguments.context.pageData['circle_id']),'\''].join(''))).setProperties(['sum(ayat_total) as totals', 'ForStudent.name as name', 'ForStudent.pic as pic', 'ForStudent.sex as sex']).setSortBy(['totals']).setGroupBy('ForStudent.objectId as ss').setPageSize(4)))

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/circle/components/4f22737d1387d729a1ec290d4a589708/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [({ 'surah': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((await Backendless.Data.of('surah_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['per=100 and student_link.circle_link.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'circle_id')),'\' AND updated > ',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))))))))),'page': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((await Backendless.Data.of('page_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['per=100 and student_link.circle_link.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'circle_id')),'\' AND updated > ',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))))))))),'juza': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((await Backendless.Data.of('juza_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['per=100 and student_link.circle_link.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'circle_id')),'\' AND updated > ',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))))))))) })]

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/circle/components/b546d226b48b103a697dc1b4d161d9f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var ayat_total;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ayat_total = (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['ForStudent.circle_link.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'circle_id')),'\' AND created > ',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))).setProperties(['sum (AyaLink.letters_count) as letters_count', 'sum (AyaLink.words_count) as words_count', 'count (AyaLink) as aya_count']).setPageSize(1)))[0];
  return [({ 'letter': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(ayat_total, 'letters_count'))))))),'word': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(ayat_total, 'words_count'))))))),'aya': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(ayat_total, 'aya_count'))))))) })];

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/circle/components/9c79f1be6acc2378e53a4786b804f646/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('ٍStudent').find(Backendless.DataQueryBuilder.create().setWhereClause((['circle_link.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'circle_id')),'\' AND (NotActive = 0 or NotActive is null)'].join(''))).setProperties(['name', 'objectId', 'sex']).setPageSize(100)))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/circle/components/185c8e1cccc8c0ad94cc63d4c3738cfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('student_detail', ({ 'student': (___arguments.context.getComponentDataStoreByUid('34692b859b16e3b36f2e2decd9f255f9')['objectId']),'name': (___arguments.context.getComponentDataStoreByUid('34692b859b16e3b36f2e2decd9f255f9')['name']),'sex': (___arguments.context.getComponentDataStoreByUid('34692b859b16e3b36f2e2decd9f255f9')['sex']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/circle/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['zeroTime'] = '\'08/20/2024\'';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/circle/components/da2811e3a8677e2d8a67bc59d90ae9a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('475480bedda872fdf245d91e057ceb74'))['height'] = '0';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/circle/components/69078f154dd6aaae3003b55b13fb8062/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('475480bedda872fdf245d91e057ceb74'))['height'] = '100%';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/circle/components/394d295b060429196f8226e5af089fe6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ((___arguments.context.pageData['sex']) == 'بنين' ? 'الطلاب' : 'الطالبات')

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/circle/components/46bb3512efb71e8f3ad9ad44a5da487d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ((___arguments.context.pageData['sex']) == 'بنين' ? 'اكثر الطلاب حفظاَ لهذا الشهر' : 'اكثر الطالبات حفظاَ لهذا الشهر')

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/circle/components/c328f6f848ad05ee78279ff7e627c981/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('حلقة ') + String(___arguments.context.pageData['name']))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/comp_boy_detail/components/f74a61674c7e734d4f9511232fbe2cd7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}


  if ((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['sex']) == 'بنين') {
    return (['اتم حفظ : ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']) <= 10 ? ' آيات ' : ' آيه ',listsGetRandomItem([' بارك الله فيه ', ' اثابه الله ', ' وفقه الله '], false)].join(''));
  } else {
    return (['اتمت حفظ : ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']) <= 10 ? ' آيات ' : ' آيه ',listsGetRandomItem([' بارك الله فيها ', ' اثابها الله', ' وفقها الله '], false)].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/comp_boy_detail/components/e37c3a4b3f5d507bba4a9c52e29a83fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String(' في حلقة ') + String(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['circle_name']));

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/comp_boy_detail/components/e352901a4747d17fcf57c288809c1f4e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var current_month;


  current_month = [(new Date((new Date())).getMonth()) + 1 >= 10 ? (new Date((new Date())).getMonth()) + 1 : String(0) + String((new Date((new Date())).getMonth()) + 1),'/01/',(new Date((new Date())).getFullYear())].join('');

  return (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['created_month >= \'',current_month,'\' AND ForStudent.circle_link.comp[circle_link].objectId=\'',(___arguments.context.pageData['comp_id']),'\''].join(''))).setProperties(['sum(ayat_total) as totals', 'ForStudent.name as name', 'ForStudent.circle_link.name as circle_name', 'ForStudent.circle_link.comp[circle_link].name as comp_name', 'ForStudent.pic as pic', 'ForStudent.sex as sex', 'ForStudent.objectId as id']).setSortBy(['totals desc']).setGroupBy('id').setPageSize(4)))

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comp_boy_detail/components/4f22737d1387d729a1ec290d4a589708/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var ayat_total;


  ayat_total = (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['ForStudent.circle_link.comp[circle_link].objectId=\'',(___arguments.context.pageData['comp_id']),'\''].join(''))).setProperties(['sum (AyaLink.letters_count) as letters_count', 'sum (AyaLink.words_count) as words_count', 'count (AyaLink) as aya_count']).setPageSize(1)))[0];
  return [({ 'letter': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send(JSON.stringify((ayat_total['letters_count'])))))),'word': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send(JSON.stringify((ayat_total['words_count'])))))),'aya': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send(JSON.stringify((ayat_total['aya_count'])))))) })];

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comp_boy_detail/components/b546d226b48b103a697dc1b4d161d9f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var ayat_total;



  return [({ 'surah': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((await Backendless.Data.of('surah_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['per=100 and student_link.circle_link.comp[circle_link].objectId=\'',(___arguments.context.pageData['comp_id']),'\''].join(''))))))))),'page': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((await Backendless.Data.of('page_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['per=100 and student_link.circle_link.comp[circle_link].objectId=\'',(___arguments.context.pageData['comp_id']),'\''].join(''))))))))),'juza': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((await Backendless.Data.of('juza_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['per=100 and student_link.circle_link.comp[circle_link].objectId=\'',(___arguments.context.pageData['comp_id']),'\''].join(''))))))))) })]

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comp_boy_detail/components/9c79f1be6acc2378e53a4786b804f646/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('circle').find(Backendless.DataQueryBuilder.create().setWhereClause((['comp[circle_link].objectId=\'',(getObjectProperty(___arguments.context.pageData, 'comp_id')),'\' AND (Student[circle_link].NotActive = 0 or Student[circle_link].NotActive is null)'].join(''))).setPageSize(100)))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comp_boy_detail/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var ayat_total;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['zeroTime'] = '\'08/20/2024\'';
  ayat_total = (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['ForStudent.circle_link.comp[circle_link].objectId=\'',(getObjectProperty(___arguments.context.pageData, 'comp_id')),'\' AND created > ',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))).setProperties(['sum (AyaLink.letters_count) as letters_count', 'sum (AyaLink.words_count) as words_count', 'count (AyaLink) as aya_count']).setPageSize(1)))[0];
  await (async function(aya, word, letter, juza_count, sura_count, page_count) {
  	C = await BackendlessUI.requireModule('https://app.m7l-e.com/A7FE1705-BFF3-D2D4-FF46-462570D69D00/18B970E9-399B-4BCF-8669-9B66CFD1E9D6/files/count-up/countUp.js');
  	//J = await BackendlessUI.requireModule('https://code.jquery.com/jquery-3.6.0.min.js');
  	S = await BackendlessUI.requireModule('https://app.m7l-e.com/A7FE1705-BFF3-D2D4-FF46-462570D69D00/18B970E9-399B-4BCF-8669-9B66CFD1E9D6/files/alert/alertify.min.js');

  	const options = {
  	duration: 10,
  	numerals: ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'],
  	};

  	Window.current_aya = aya;
  	Window.current_word = word;
  	Window.current_letter = letter;
  	Window.current_juza = juza_count;
  	Window.current_sura = sura_count;
  	Window.current_page = page_count;

  	Window.ayat = new C.CountUp('main_aya_block', Window.current_aya,options);
  	Window.ayat.start()

  	Window.words = new C.CountUp('main_word_block', Window.current_word,options);
  	Window.words.start()

  	Window.letters = new C.CountUp('main_letter_block', Window.current_letter,options);
  	Window.letters.start()

  	Window.juza = new C.CountUp('main_juza_block', Window.current_juza,options);
  	Window.juza.start()

  	Window.sura = new C.CountUp('main_sura_block', Window.current_sura,options);
  	Window.sura.start()

  	Window.page = new C.CountUp('main_page_block', Window.current_page,options);
  	Window.page.start()





  	S.defaults = {
  	        // dialogs defaults
  	        autoReset:true,
  	        basic:false,
  	        closable:true,
  	        closableByDimmer:true,
  	        invokeOnCloseOff:false,
  	        frameless:false,
  	        defaultFocusOff:false,
  	        maintainFocus:true, // <== global default not per instance, applies to all dialogs
  	        maximizable:true,
  	        modal:true,
  	        movable:true,
  	        moveBounded:false,
  	        overflow:true,
  	        padding: true,
  	        pinnable:true,
  	        pinned:true,
  	        preventBodyShift:false, // <== global default not per instance, applies to all dialogs
  	        resizable:true,
  	        startMaximized:false,
  	        transition:'pulse',
  	        transitionOff:false,
  	        tabbable:'button:not(:disabled):not(.ajs-reset),[href]:not(:disabled):not(.ajs-reset),input:not(:disabled):not(.ajs-reset),select:not(:disabled):not(.ajs-reset),textarea:not(:disabled):not(.ajs-reset),[tabindex]:not([tabindex^="-"]):not(:disabled):not(.ajs-reset)',  // <== global default not per instance, applies to all dialogs

  	        // notifier defaults
  	        notifier:{
  	        // auto-dismiss wait time (in seconds)
  	            delay:15,
  	        // default position
  	            position:'top-left',
  	        // adds a close button to notifier messages
  	            closeButton: false,
  	        // provides the ability to rename notifier classes
  	            classes : {
  	                base: 'alertify-notifier',
  	                prefix:'ajs-',
  	                message: 'ajs-message',
  	                top: 'ajs-top',
  	                right: 'ajs-right',
  	                bottom: 'ajs-bottom',
  	                left: 'ajs-left',
  	                center: 'ajs-center',
  	                visible: 'ajs-visible',
  	                hidden: 'ajs-hidden',
  	                close: 'ajs-close'
  	            }
  	        },

  	        // language resources
  	        glossary:{
  	            // dialogs default title
  	            title:'اشعار',
  	            // ok button text
  	            ok: 'موافق',
  	            // cancel button text
  	            cancel: 'الغاء'
  	        },

  	        // theme settings
  	        theme:{
  	            // class name attached to prompt dialog input textbox.
  	            input:'ajs-input',
  	            // class name attached to ok button
  	            ok:'ajs-ok',
  	            // class name attached to cancel button
  	            cancel:'ajs-cancel'
  	        },
  	        // global hooks
  	        hooks:{
  	            // invoked before initializing any dialog
  	            preinit:function(instance){},
  	            // invoked after initializing any dialog
  	            postinit:function(instance){},
  	        },
  	    };



  })((getObjectProperty(ayat_total, 'aya_count')), (getObjectProperty(ayat_total, 'words_count')), (getObjectProperty(ayat_total, 'letters_count')), (await Backendless.Data.of('juza_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['per=100 and student_link.circle_link.comp[circle_link].objectId=\'',(getObjectProperty(___arguments.context.pageData, 'comp_id')),'\' AND updated > ',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))))), (await Backendless.Data.of('surah_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['per=100 and student_link.circle_link.comp[circle_link].objectId=\'',(getObjectProperty(___arguments.context.pageData, 'comp_id')),'\' AND updated > ',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))))), (await Backendless.Data.of('page_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['per=100 and student_link.circle_link.comp[circle_link].objectId=\'',(getObjectProperty(___arguments.context.pageData, 'comp_id')),'\' AND updated > ',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/comp_boy_detail/components/da2811e3a8677e2d8a67bc59d90ae9a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('475480bedda872fdf245d91e057ceb74'))['height'] = '0';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comp_boy_detail/components/941f517833d3eec8108f461f626225bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('student_detail', ({ 'student': (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['objectId']),'name': (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['name']),'sex': (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['sex']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comp_boy_detail/components/3da9edfeb8aaa1a6c3471e24874c6bab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('circle', ({ 'circle_id': (___arguments.context.getComponentDataStoreByUid('34692b859b16e3b36f2e2decd9f255f9')['objectId']),'name': (___arguments.context.getComponentDataStoreByUid('34692b859b16e3b36f2e2decd9f255f9')['name']),'sex': (___arguments.context.getComponentDataStoreByUid('34692b859b16e3b36f2e2decd9f255f9')['sex']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comp_boy_detail/components/141fea665fab1f597f910b97962255a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('475480bedda872fdf245d91e057ceb74'))['height'] = '100%';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comp_girl_detail/components/f74a61674c7e734d4f9511232fbe2cd7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}


  if ((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['sex']) == 'بنين') {
    return (['اتم حفظ : ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']) <= 10 ? ' آيات ' : ' آيه ',listsGetRandomItem([' بارك الله فيه ', ' اثابه الله ', ' وفقه الله '], false)].join(''));
  } else {
    return (['اتمت حفظ : ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']) <= 10 ? ' آيات ' : ' آيه ',listsGetRandomItem([' بارك الله فيها ', ' اثابها الله', ' وفقها الله '], false)].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/comp_girl_detail/components/e37c3a4b3f5d507bba4a9c52e29a83fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String(' في حلقة ') + String(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['circle_name']));

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/comp_girl_detail/components/e352901a4747d17fcf57c288809c1f4e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var current_month;


  current_month = [(new Date((new Date())).getMonth()) + 1 >= 10 ? (new Date((new Date())).getMonth()) + 1 : String(0) + String((new Date((new Date())).getMonth()) + 1),'/01/',(new Date((new Date())).getFullYear())].join('');

  return (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['created_month >= \'',current_month,'\' AND ForStudent.circle_link.comp[circle_link].objectId=\'',(___arguments.context.pageData['comp_id']),'\''].join(''))).setProperties(['sum(ayat_total) as totals', 'ForStudent.name as name', 'ForStudent.circle_link.name as circle_name', 'ForStudent.circle_link.comp[circle_link].name as comp_name', 'ForStudent.pic as pic', 'ForStudent.sex as sex', 'ForStudent.objectId as id']).setSortBy(['totals desc']).setGroupBy('id').setPageSize(4)))

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comp_girl_detail/components/4f22737d1387d729a1ec290d4a589708/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var ayat_total;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ayat_total = (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['ForStudent.circle_link.comp[circle_link].objectId=\'',(getObjectProperty(___arguments.context.pageData, 'comp_id')),'\' AND created > ',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))).setProperties(['sum (AyaLink.letters_count) as letters_count', 'sum (AyaLink.words_count) as words_count', 'count (AyaLink) as aya_count']).setPageSize(1)))[0];
  return [({ 'letter': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(ayat_total, 'letters_count'))))))),'word': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(ayat_total, 'words_count'))))))),'aya': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(ayat_total, 'aya_count'))))))) })];

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comp_girl_detail/components/b546d226b48b103a697dc1b4d161d9f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [({ 'surah': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((await Backendless.Data.of('surah_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['per=100 and student_link.circle_link.comp[circle_link].objectId=\'',(getObjectProperty(___arguments.context.pageData, 'comp_id')),'\' AND updated > ',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))))))))),'page': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((await Backendless.Data.of('page_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['per=100 and student_link.circle_link.comp[circle_link].objectId=\'',(getObjectProperty(___arguments.context.pageData, 'comp_id')),'\' AND updated > ',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))))))))),'juza': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((await Backendless.Data.of('juza_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['per=100 and student_link.circle_link.comp[circle_link].objectId=\'',(getObjectProperty(___arguments.context.pageData, 'comp_id')),'\' AND updated > ',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))))))))) })]

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comp_girl_detail/components/9c79f1be6acc2378e53a4786b804f646/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('circle').find(Backendless.DataQueryBuilder.create().setWhereClause((['comp[circle_link].objectId=\'',(getObjectProperty(___arguments.context.pageData, 'comp_id')),'\' AND (Student[circle_link].NotActive = 0 or Student[circle_link].NotActive is null)'].join(''))).setPageSize(100)))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comp_girl_detail/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['zeroTime'] = '\'08/20/2024\'';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/comp_girl_detail/components/da2811e3a8677e2d8a67bc59d90ae9a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('475480bedda872fdf245d91e057ceb74'))['height'] = '0';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comp_girl_detail/components/69078f154dd6aaae3003b55b13fb8062/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('475480bedda872fdf245d91e057ceb74'))['height'] = '100%';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comp_girl_detail/components/96bb5a93a43384ffb0997d5a89b744a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('student_detail', ({ 'student': (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['id']),'name': (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['name']),'sex': (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['sex']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comp_girl_detail/components/3da9edfeb8aaa1a6c3471e24874c6bab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('circle', ({ 'circle_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('34692b859b16e3b36f2e2decd9f255f9'), 'objectId')),'name': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('34692b859b16e3b36f2e2decd9f255f9'), 'name')),'sex': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('34692b859b16e3b36f2e2decd9f255f9'), 'sex')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/comps/components/f74a61674c7e734d4f9511232fbe2cd7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}


  if ((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['sex']) == 'بنين') {
    return (['اتم حفظ : ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']) <= 10 ? ' آيات ' : ' آيه ',listsGetRandomItem([' بارك الله فيه ', ' اثابه الله ', ' وفقه الله '], false)].join(''));
  } else {
    return (['اتمت حفظ : ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']) <= 10 ? ' آيات ' : ' آيه ',listsGetRandomItem([' بارك الله فيها ', ' اثابها الله', ' وفقها الله '], false)].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/comps/components/e37c3a4b3f5d507bba4a9c52e29a83fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['comp_name']),' في حلقة ',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['circle_name'])].join(''));

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/comps/components/e352901a4747d17fcf57c288809c1f4e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var current_month;


  current_month = [(new Date((new Date())).getMonth()) + 1 >= 10 ? (new Date((new Date())).getMonth()) + 1 : String(0) + String((new Date((new Date())).getMonth()) + 1),'/01/',(new Date((new Date())).getFullYear())].join('');

  return (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['created_month >= \'',current_month,'\' AND ForStudent.sex=\'بنين\''].join(''))).setProperties(['sum(ayat_total) as totals', 'ForStudent.name as name', 'ForStudent.circle_link.name as circle_name', 'ForStudent.circle_link.comp[circle_link].name as comp_name', 'ForStudent.pic as pic', 'ForStudent.objectId as id', 'ForStudent.sex']).setSortBy('totals desc').setGroupBy('id').setPageSize(4)))

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comps/components/c2ec81484eb37de13004149e1919d872/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var current_month;


  current_month = [(new Date((new Date())).getMonth()) + 1 >= 10 ? (new Date((new Date())).getMonth()) + 1 : String(0) + String((new Date((new Date())).getMonth()) + 1),'/01/',(new Date((new Date())).getFullYear())].join('');

  return (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['created_month >= \'',current_month,'\' AND ByUser.sex=\'بنين\''].join(''))).setProperties(['count(objectId) as totals', 'ForStudent.circle_link.comp[circle_link].name as comp_name', 'ForStudent.circle_link.comp[circle_link].photo as comp_photo', 'ForStudent.circle_link.comp[circle_link].objectId as id']).setSortBy('totals desc').setGroupBy('id').setPageSize(4)))

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comps/components/4f22737d1387d729a1ec290d4a589708/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var ayat_total;


  ayat_total = (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause('ForStudent.sex=\'بنين\'').setProperties(['sum (AyaLink.letters_count) as letters_count', 'sum (AyaLink.words_count) as words_count', 'count (AyaLink) as aya_count']).setPageSize(1)))[0];
  return [({ 'letter': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send(JSON.stringify((ayat_total['letters_count'])))))),'word': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send(JSON.stringify((ayat_total['words_count'])))))),'aya': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send(JSON.stringify((ayat_total['aya_count'])))))) })];

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comps/components/b546d226b48b103a697dc1b4d161d9f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
    
  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comps/components/185c8e1cccc8c0ad94cc63d4c3738cfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    
  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comps/components/3afa833b00aa29944324c082b66a49b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}


  return (['اتم ادخال: ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('8674d22ae3aa59ef784c419c122d1bab')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('8674d22ae3aa59ef784c419c122d1bab')['totals']) <= 10 ? ' عملية ' : '  عمليات ',listsGetRandomItem([' بارك الله فيهم ', ' اثابهم الله ', ' وفقهم الله '], false)].join(''));

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/comps/components/2ad2bc3ae6e8e3687a99992d205ff9a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c775ed9a5d6615a1292b2917c256a7de'))['height'] = '100%';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comps/components/78b5ff541f855147128abd824a96e589/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c775ed9a5d6615a1292b2917c256a7de'))['height'] = '0';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comps/components/7edbe549ba6ce3e92b89f36d73e88a5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var current_month;


  current_month = [(new Date((new Date())).getMonth()) + 1 >= 10 ? (new Date((new Date())).getMonth()) + 1 : String(0) + String((new Date((new Date())).getMonth()) + 1),'/01/',(new Date((new Date())).getFullYear())].join('');

  return (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['created_month >= \'',current_month,'\' AND ByUser.sex=\'بنين\''].join(''))).setProperties(['count(objectId) as totals', 'ByUser.name as name', 'ByUser.circle[user_link].name as circle_name', 'ByUser.circle[user_link].comp[circle_link].name as comp_name', 'ByUser.photo as pic', 'ByUser.objectId as id']).setSortBy('totals desc').setGroupBy('id').setPageSize(4)))

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comps/components/a49f55faf65db9a32926feec78f91ee9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}


  return (['اتم ادخال: ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('93bd7ac7b98431938278bb31b309eea7')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('93bd7ac7b98431938278bb31b309eea7')['totals']) <= 10 ? ' عملية ' : '  عمليات ',listsGetRandomItem([' بارك الله فيه ', ' اثابه الله ', ' وفقه الله '], false)].join(''));

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/comps/components/81b203328e7fe2199589ab2fddd981b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('comp_boy_detail', ({ 'comp_id': (___arguments.context.getComponentDataStoreByUid('8674d22ae3aa59ef784c419c122d1bab')['id']),'name': (___arguments.context.getComponentDataStoreByUid('8674d22ae3aa59ef784c419c122d1bab')['comp_name']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comps/components/96bb5a93a43384ffb0997d5a89b744a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('student_detail', ({ 'student': (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['id']),'name': (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['name']),'sex': (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['sex']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comps/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var ayat_total;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['zeroTime'] = '\'08/20/2024\'';
  ayat_total = (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((String('ForStudent.sex=\'بنين\' AND created > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))).setProperties(['sum (AyaLink.letters_count) as letters_count', 'sum (AyaLink.words_count) as words_count', 'count (AyaLink) as aya_count']).setPageSize(1)))[0];
  await (async function(aya, word, letter, juza_count, sura_count, page_count) {
  	C = await BackendlessUI.requireModule('https://app.m7l-e.com/A7FE1705-BFF3-D2D4-FF46-462570D69D00/18B970E9-399B-4BCF-8669-9B66CFD1E9D6/files/count-up/countUp.js');
  	//J = await BackendlessUI.requireModule('https://code.jquery.com/jquery-3.6.0.min.js');
  	S = await BackendlessUI.requireModule('https://app.m7l-e.com/A7FE1705-BFF3-D2D4-FF46-462570D69D00/18B970E9-399B-4BCF-8669-9B66CFD1E9D6/files/alert/alertify.min.js');

  	const options = {
  	duration: 50,
  	numerals: ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'],
  	};

  	Window.current_aya = aya;
  	Window.current_word = word;
  	Window.current_letter = letter;
  	Window.current_juza = juza_count;
  	Window.current_sura = sura_count;
  	Window.current_page = page_count;

  	Window.ayat = new C.CountUp('main_aya_block', Window.current_aya,options);
  	Window.ayat.start()

  	Window.words = new C.CountUp('main_word_block', Window.current_word,options);
  	Window.words.start()

  	Window.letters = new C.CountUp('main_letter_block', Window.current_letter,options);
  	Window.letters.start()

  	Window.juza = new C.CountUp('main_juza_block', Window.current_juza,options);
  	Window.juza.start()

  	Window.sura = new C.CountUp('main_sura_block', Window.current_sura,options);
  	Window.sura.start()

  	Window.page = new C.CountUp('main_page_block', Window.current_page,options);
  	Window.page.start()





  	S.defaults = {
  	        // dialogs defaults
  	        autoReset:true,
  	        basic:false,
  	        closable:true,
  	        closableByDimmer:true,
  	        invokeOnCloseOff:false,
  	        frameless:false,
  	        defaultFocusOff:false,
  	        maintainFocus:true, // <== global default not per instance, applies to all dialogs
  	        maximizable:true,
  	        modal:true,
  	        movable:true,
  	        moveBounded:false,
  	        overflow:true,
  	        padding: true,
  	        pinnable:true,
  	        pinned:true,
  	        preventBodyShift:false, // <== global default not per instance, applies to all dialogs
  	        resizable:true,
  	        startMaximized:false,
  	        transition:'pulse',
  	        transitionOff:false,
  	        tabbable:'button:not(:disabled):not(.ajs-reset),[href]:not(:disabled):not(.ajs-reset),input:not(:disabled):not(.ajs-reset),select:not(:disabled):not(.ajs-reset),textarea:not(:disabled):not(.ajs-reset),[tabindex]:not([tabindex^="-"]):not(:disabled):not(.ajs-reset)',  // <== global default not per instance, applies to all dialogs

  	        // notifier defaults
  	        notifier:{
  	        // auto-dismiss wait time (in seconds)
  	            delay:15,
  	        // default position
  	            position:'top-left',
  	        // adds a close button to notifier messages
  	            closeButton: false,
  	        // provides the ability to rename notifier classes
  	            classes : {
  	                base: 'alertify-notifier',
  	                prefix:'ajs-',
  	                message: 'ajs-message',
  	                top: 'ajs-top',
  	                right: 'ajs-right',
  	                bottom: 'ajs-bottom',
  	                left: 'ajs-left',
  	                center: 'ajs-center',
  	                visible: 'ajs-visible',
  	                hidden: 'ajs-hidden',
  	                close: 'ajs-close'
  	            }
  	        },

  	        // language resources
  	        glossary:{
  	            // dialogs default title
  	            title:'اشعار',
  	            // ok button text
  	            ok: 'موافق',
  	            // cancel button text
  	            cancel: 'الغاء'
  	        },

  	        // theme settings
  	        theme:{
  	            // class name attached to prompt dialog input textbox.
  	            input:'ajs-input',
  	            // class name attached to ok button
  	            ok:'ajs-ok',
  	            // class name attached to cancel button
  	            cancel:'ajs-cancel'
  	        },
  	        // global hooks
  	        hooks:{
  	            // invoked before initializing any dialog
  	            preinit:function(instance){},
  	            // invoked after initializing any dialog
  	            postinit:function(instance){},
  	        },
  	    };



  })((getObjectProperty(ayat_total, 'aya_count')), (getObjectProperty(ayat_total, 'words_count')), (getObjectProperty(ayat_total, 'letters_count')), (await Backendless.Data.of('juza_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('per=100 and student_link.sex=\'بنين\' AND updated > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))))), (await Backendless.Data.of('surah_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('per=100 and student_link.sex=\'بنين\' AND updated > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))))), (await Backendless.Data.of('page_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('per=100 and student_link.sex=\'بنين\' AND updated > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/comps/components/3da9edfeb8aaa1a6c3471e24874c6bab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('comp_boy_detail', ({ 'comp_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('34692b859b16e3b36f2e2decd9f255f9'), 'objectId')),'name': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('34692b859b16e3b36f2e2decd9f255f9'), 'name')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/comps/components/9c79f1be6acc2378e53a4786b804f646/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
      return (await Backendless.Data.of('comp').find(Backendless.DataQueryBuilder.create().setWhereClause('sex=\'بنين\' AND (circle_link.Student[circle_link].NotActive = 0 or circle_link.Student[circle_link].NotActive is null)').setPageSize(100)))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comps/components/3a21407d6dd1b7e5afc34d7220f59961/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/comps_girls/components/f74a61674c7e734d4f9511232fbe2cd7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}


  if ((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['sex']) == 'بنين') {
    return (['اتم حفظ : ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']) <= 10 ? ' آيات ' : ' آيه ',listsGetRandomItem([' بارك الله فيه ', ' اثابه الله ', ' وفقه الله '], false)].join(''));
  } else {
    return (['اتمت حفظ : ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']) <= 10 ? ' آيات ' : ' آيه ',listsGetRandomItem([' بارك الله فيها ', ' اثابها الله', ' وفقها الله '], false)].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/comps_girls/components/e37c3a4b3f5d507bba4a9c52e29a83fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['comp_name']),' في حلقة ',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['circle_name'])].join(''));

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/comps_girls/components/e352901a4747d17fcf57c288809c1f4e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var current_month;


  current_month = [(new Date((new Date())).getMonth()) + 1 >= 10 ? (new Date((new Date())).getMonth()) + 1 : String(0) + String((new Date((new Date())).getMonth()) + 1),'/01/',(new Date((new Date())).getFullYear())].join('');

  return (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['created_month >= \'',current_month,'\' AND ForStudent.sex=\'بنات\''].join(''))).setProperties(['sum(ayat_total) as totals', 'ForStudent.name as name', 'ForStudent.circle_link.name as circle_name', 'ForStudent.circle_link.comp[circle_link].name as comp_name', 'ForStudent.pic as pic', 'ForStudent.objectId as id']).setSortBy('totals desc').setGroupBy('id').setPageSize(4)))

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comps_girls/components/c2ec81484eb37de13004149e1919d872/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var current_month;


  current_month = [(new Date((new Date())).getMonth()) + 1 >= 10 ? (new Date((new Date())).getMonth()) + 1 : String(0) + String((new Date((new Date())).getMonth()) + 1),'/01/',(new Date((new Date())).getFullYear())].join('');

  return (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['created_month >= \'',current_month,'\' AND ByUser.sex=\'بنات\''].join(''))).setProperties(['count(objectId) as totals', 'ForStudent.circle_link.comp[circle_link].name as comp_name', 'ForStudent.circle_link.comp[circle_link].photo as comp_photo', 'ForStudent.circle_link.comp[circle_link].objectId as id']).setSortBy('totals desc').setGroupBy('id').setPageSize(4)))

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comps_girls/components/4f22737d1387d729a1ec290d4a589708/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var ayat_total;


  ayat_total = (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause('ForStudent.sex=\'بنات\'').setProperties(['sum (AyaLink.letters_count) as letters_count', 'sum (AyaLink.words_count) as words_count', 'count (AyaLink) as aya_count']).setPageSize(1)))[0];
  return [({ 'letter': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send(JSON.stringify((ayat_total['letters_count'])))))),'word': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send(JSON.stringify((ayat_total['words_count'])))))),'aya': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send(JSON.stringify((ayat_total['aya_count'])))))) })];

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comps_girls/components/b546d226b48b103a697dc1b4d161d9f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var ayat_total;



  return [({ 'surah': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((await Backendless.Data.of('surah_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('per=100 and student_link.sex=\'بنات\''))))))),'page': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((await Backendless.Data.of('page_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('per=100 and student_link.sex=\'بنات\''))))))),'juza': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((await Backendless.Data.of('juza_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('per=100 and student_link.sex=\'بنات\''))))))) })]

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comps_girls/components/9c79f1be6acc2378e53a4786b804f646/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
      console.log('abc');

  return (await Backendless.Data.of('comp').find(Backendless.DataQueryBuilder.create().setWhereClause('sex=\'بنات\' AND (circle_link.Student[circle_link].NotActive = 0 or circle_link.Student[circle_link].NotActive is null)').setPageSize(100)))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comps_girls/components/185c8e1cccc8c0ad94cc63d4c3738cfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    
  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comps_girls/components/3afa833b00aa29944324c082b66a49b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}


  return (['اتم ادخال: ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('8674d22ae3aa59ef784c419c122d1bab')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('8674d22ae3aa59ef784c419c122d1bab')['totals']) <= 10 ? ' عملية ' : '  عمليات ',listsGetRandomItem([' بارك الله فيهم ', ' اثابهم الله ', ' وفقهم الله '], false)].join(''));

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/comps_girls/components/2ad2bc3ae6e8e3687a99992d205ff9a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c775ed9a5d6615a1292b2917c256a7de'))['height'] = '100%';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comps_girls/components/78b5ff541f855147128abd824a96e589/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c775ed9a5d6615a1292b2917c256a7de'))['height'] = '0';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comps_girls/components/7edbe549ba6ce3e92b89f36d73e88a5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var current_month;


  current_month = [(new Date((new Date())).getMonth()) + 1 >= 10 ? (new Date((new Date())).getMonth()) + 1 : String(0) + String((new Date((new Date())).getMonth()) + 1),'/01/',(new Date((new Date())).getFullYear())].join('');

  return (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['created_month >= \'',current_month,'\' AND ByUser.sex=\'بنات\''].join(''))).setProperties(['count(objectId) as totals', 'ByUser.name as name', 'ByUser.circle[user_link].name as circle_name', 'ByUser.circle[user_link].comp[circle_link].name as comp_name', 'ByUser.photo as pic', 'ByUser.objectId as id']).setSortBy('totals desc').setGroupBy('id').setPageSize(4)))

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/comps_girls/components/a49f55faf65db9a32926feec78f91ee9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}


  return (['اتمت ادخال: ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('93bd7ac7b98431938278bb31b309eea7')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('93bd7ac7b98431938278bb31b309eea7')['totals']) <= 10 ? '  عمليات ' : ' عملية ',listsGetRandomItem([' بارك الله فيها ', ' اثابها الله ', ' وفقها الله '], false)].join(''));

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/comps_girls/components/96bb5a93a43384ffb0997d5a89b744a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('student_detail', ({ 'student': (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['id']),'name': (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['name']),'sex': (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['sex']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comps_girls/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var ayat_total;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['zeroTime'] = '\'08/20/2024\'';
  ayat_total = (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((String('ForStudent.sex=\'بنات\'  AND created > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))).setProperties(['sum (AyaLink.letters_count) as letters_count', 'sum (AyaLink.words_count) as words_count', 'count (AyaLink) as aya_count']).setPageSize(1)))[0];
  await (async function(aya, word, letter, juza_count, sura_count, page_count) {
  	C = await BackendlessUI.requireModule('https://app.m7l-e.com/A7FE1705-BFF3-D2D4-FF46-462570D69D00/18B970E9-399B-4BCF-8669-9B66CFD1E9D6/files/count-up/countUp.js');
  	//J = await BackendlessUI.requireModule('https://code.jquery.com/jquery-3.6.0.min.js');
  	S = await BackendlessUI.requireModule('https://app.m7l-e.com/A7FE1705-BFF3-D2D4-FF46-462570D69D00/18B970E9-399B-4BCF-8669-9B66CFD1E9D6/files/alert/alertify.min.js');

  	const options = {
  	duration: 10,
  	numerals: ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'],
  	};

  	Window.current_aya = aya;
  	Window.current_word = word;
  	Window.current_letter = letter;
  	Window.current_juza = juza_count;
  	Window.current_sura = sura_count;
  	Window.current_page = page_count;

  	Window.ayat = new C.CountUp('main_aya_block', Window.current_aya,options);
  	Window.ayat.start()

  	Window.words = new C.CountUp('main_word_block', Window.current_word,options);
  	Window.words.start()

  	Window.letters = new C.CountUp('main_letter_block', Window.current_letter,options);
  	Window.letters.start()

  	Window.juza = new C.CountUp('main_juza_block', Window.current_juza,options);
  	Window.juza.start()

  	Window.sura = new C.CountUp('main_sura_block', Window.current_sura,options);
  	Window.sura.start()

  	Window.page = new C.CountUp('main_page_block', Window.current_page,options);
  	Window.page.start()





  	S.defaults = {
  	        // dialogs defaults
  	        autoReset:true,
  	        basic:false,
  	        closable:true,
  	        closableByDimmer:true,
  	        invokeOnCloseOff:false,
  	        frameless:false,
  	        defaultFocusOff:false,
  	        maintainFocus:true, // <== global default not per instance, applies to all dialogs
  	        maximizable:true,
  	        modal:true,
  	        movable:true,
  	        moveBounded:false,
  	        overflow:true,
  	        padding: true,
  	        pinnable:true,
  	        pinned:true,
  	        preventBodyShift:false, // <== global default not per instance, applies to all dialogs
  	        resizable:true,
  	        startMaximized:false,
  	        transition:'pulse',
  	        transitionOff:false,
  	        tabbable:'button:not(:disabled):not(.ajs-reset),[href]:not(:disabled):not(.ajs-reset),input:not(:disabled):not(.ajs-reset),select:not(:disabled):not(.ajs-reset),textarea:not(:disabled):not(.ajs-reset),[tabindex]:not([tabindex^="-"]):not(:disabled):not(.ajs-reset)',  // <== global default not per instance, applies to all dialogs

  	        // notifier defaults
  	        notifier:{
  	        // auto-dismiss wait time (in seconds)
  	            delay:15,
  	        // default position
  	            position:'top-left',
  	        // adds a close button to notifier messages
  	            closeButton: false,
  	        // provides the ability to rename notifier classes
  	            classes : {
  	                base: 'alertify-notifier',
  	                prefix:'ajs-',
  	                message: 'ajs-message',
  	                top: 'ajs-top',
  	                right: 'ajs-right',
  	                bottom: 'ajs-bottom',
  	                left: 'ajs-left',
  	                center: 'ajs-center',
  	                visible: 'ajs-visible',
  	                hidden: 'ajs-hidden',
  	                close: 'ajs-close'
  	            }
  	        },

  	        // language resources
  	        glossary:{
  	            // dialogs default title
  	            title:'اشعار',
  	            // ok button text
  	            ok: 'موافق',
  	            // cancel button text
  	            cancel: 'الغاء'
  	        },

  	        // theme settings
  	        theme:{
  	            // class name attached to prompt dialog input textbox.
  	            input:'ajs-input',
  	            // class name attached to ok button
  	            ok:'ajs-ok',
  	            // class name attached to cancel button
  	            cancel:'ajs-cancel'
  	        },
  	        // global hooks
  	        hooks:{
  	            // invoked before initializing any dialog
  	            preinit:function(instance){},
  	            // invoked after initializing any dialog
  	            postinit:function(instance){},
  	        },
  	    };



  })((getObjectProperty(ayat_total, 'aya_count')), (getObjectProperty(ayat_total, 'words_count')), (getObjectProperty(ayat_total, 'letters_count')), (await Backendless.Data.of('juza_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('per=100 and student_link.sex=\'بنات\' AND updated > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))))), (await Backendless.Data.of('surah_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('per=100 and student_link.sex=\'بنات\' AND updated >') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))))), (await Backendless.Data.of('page_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('per=100 and student_link.sex=\'بنات\' AND updated >') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/comps_girls/components/81b203328e7fe2199589ab2fddd981b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('comp_girl_detail', ({ 'comp_id': (___arguments.context.getComponentDataStoreByUid('8674d22ae3aa59ef784c419c122d1bab')['id']),'name': (___arguments.context.getComponentDataStoreByUid('8674d22ae3aa59ef784c419c122d1bab')['comp_name']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/comps_girls/components/3da9edfeb8aaa1a6c3471e24874c6bab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('comp_girl_detail', ({ 'comp_id': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('34692b859b16e3b36f2e2decd9f255f9'), 'objectId')),'name': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('34692b859b16e3b36f2e2decd9f255f9'), 'name')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ddd/components/f74a61674c7e734d4f9511232fbe2cd7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}


  console.log('cell logic executed');
  if ((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['sex']) == 'بنين') {
    return (['اتم حفظ : ','<b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']),'</b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']) <= 10 ? ' آيات ' : ' آيه ',listsGetRandomItem([' بارك الله فيه ', ' اثابه الله ', ' وفقه الله '], false)].join(''));
  } else {
    return (['اتمت حفظ : ','<b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']),'</b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']) <= 10 ? ' آيات ' : ' آيه ',listsGetRandomItem([' بارك الله فيها ', ' اثابها الله', ' وفقها الله '], false)].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/ddd/components/e37c3a4b3f5d507bba4a9c52e29a83fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['comp_name']),' في حلقة ',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['circle_name'])].join(''));

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/ddd/components/96bb5a93a43384ffb0997d5a89b744a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('student_detail', ({ 'student': (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['id']),'name': (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['name']),'sex': (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['sex']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ddd/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      await (async function() {
  	J = await BackendlessUI.requireModule('https://code.jquery.com/jquery-3.6.0.min.js');
  	S = await BackendlessUI.requireModule('https://app.m7l-e.com/A7FE1705-BFF3-D2D4-FF46-462570D69D00/18B970E9-399B-4BCF-8669-9B66CFD1E9D6/files/alert/alertify.min.js');

  	console.log('this is custom js code on the Page element.');
  	console.log(alertify);

  })();

  },  
  /* handler:onEnter */
  /* handler:onLeave */
  onLeave(___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getRTSubscriptions() { const subs = getGlobalEntitiesMap('subscriptions');subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`RT subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}


  getRTSubscriptions().remove('RT');;

  },  
  /* handler:onLeave */
  /* content */
}))

define('./pages/ddd/components/9cf20eee1a32b67dc527b585c957ba76/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    var current_month;


  console.log('row logic executed');
  current_month = [(new Date((new Date())).getMonth()) + 1 >= 10 ? (new Date((new Date())).getMonth()) + 1 : String(0) + String((new Date((new Date())).getMonth()) + 1),'/01/',(new Date((new Date())).getFullYear())].join('');
  ___arguments.context.dataModel['items'] = (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['created_month >= \'',current_month,'\''].join(''))).setProperties(['sum(ayat_total) as totals', 'ForStudent.name as name', 'ForStudent.circle_link.name as circle_name', 'ForStudent.circle_link.comp[circle_link].name as comp_name', 'ForStudent.pic as pic', 'ForStudent.objectId as id', 'ForStudent.sex']).setSortBy('totals desc').setGroupBy('id').setPageSize(4)));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/landing/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var circles, circle;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	J = await BackendlessUI.requireModule('https://code.jquery.com/jquery-3.6.0.min.js');
  	S = await BackendlessUI.requireModule('https://app.m7l-e.com/A7FE1705-BFF3-D2D4-FF46-462570D69D00/18B970E9-399B-4BCF-8669-9B66CFD1E9D6/files/alert/alertify.min.js');

  	S.defaults = {
  	        // dialogs defaults
  	        autoReset:true,
  	        basic:false,
  	        closable:true,
  	        closableByDimmer:true,
  	        invokeOnCloseOff:false,
  	        frameless:false,
  	        defaultFocusOff:false,
  	        maintainFocus:true, // <== global default not per instance, applies to all dialogs
  	        maximizable:true,
  	        modal:true,
  	        movable:true,
  	        moveBounded:false,
  	        overflow:true,
  	        padding: true,
  	        pinnable:true,
  	        pinned:true,
  	        preventBodyShift:false, // <== global default not per instance, applies to all dialogs
  	        resizable:true,
  	        startMaximized:false,
  	        transition:'pulse',
  	        transitionOff:false,
  	        tabbable:'button:not(:disabled):not(.ajs-reset),[href]:not(:disabled):not(.ajs-reset),input:not(:disabled):not(.ajs-reset),select:not(:disabled):not(.ajs-reset),textarea:not(:disabled):not(.ajs-reset),[tabindex]:not([tabindex^="-"]):not(:disabled):not(.ajs-reset)',  // <== global default not per instance, applies to all dialogs

  	        // notifier defaults
  	        notifier:{
  	        // auto-dismiss wait time (in seconds)
  	            delay:5,
  	        // default position
  	            position:'top-left',
  	        // adds a close button to notifier messages
  	            closeButton: false,
  	        // provides the ability to rename notifier classes
  	            classes : {
  	                base: 'alertify-notifier',
  	                prefix:'ajs-',
  	                message: 'ajs-message',
  	                top: 'ajs-top',
  	                right: 'ajs-right',
  	                bottom: 'ajs-bottom',
  	                left: 'ajs-left',
  	                center: 'ajs-center',
  	                visible: 'ajs-visible',
  	                hidden: 'ajs-hidden',
  	                close: 'ajs-close'
  	            }
  	        },

  	        // language resources
  	        glossary:{
  	            // dialogs default title
  	            title:'اشعار',
  	            // ok button text
  	            ok: 'موافق',
  	            // cancel button text
  	            cancel: 'الغاء'
  	        },

  	        // theme settings
  	        theme:{
  	            // class name attached to prompt dialog input textbox.
  	            input:'ajs-input',
  	            // class name attached to ok button
  	            ok:'ajs-ok',
  	            // class name attached to cancel button
  	            cancel:'ajs-cancel'
  	        },
  	        // global hooks
  	        hooks:{
  	            // invoked before initializing any dialog
  	            preinit:function(instance){},
  	            // invoked after initializing any dialog
  	            postinit:function(instance){},
  	        },
  	    };

  })();
  if (await Backendless.UserService.isValidLogin()) {
    ___arguments.context.pageData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.pageData['PagesListArray'] = (getObjectProperty(((await Backendless.Data.of('PageSelectJSON').find(Backendless.DataQueryBuilder.create().setProperties(['json']).setPageSize(1)))[0]), 'json'));
    circles = (await Backendless.Data.of('circle').find(Backendless.DataQueryBuilder.create().setWhereClause((['user_link.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join(''))).setProperties(['objectId', 'name']).setPageSize(5)));
    for (var circle_index in circles) {
      circle = circles[circle_index];
      circle['students'] = (await Backendless.Data.of('Student').find(Backendless.DataQueryBuilder.create().setWhereClause((['circle_link.objectId=\'',(getObjectProperty(circle, 'objectId')),'\' AND (NotActive = 0 or NotActive is null)'].join(''))).setProperties(['objectId', 'name', 'LatestPage', 'LatestPage', 'pic', 'LatestAya.aya_number_ar as aya_number', 'LatestAya.Surah[aya_link].name as surah_name', 'sex']).setPageSize(100)));
    }
    ___arguments.context.pageData['StudentsListArray'] = circles;
    ___arguments.context.pageData['SurahList'] = [];
    ___arguments.context.pageData['SelectedAyat'] = [];
    ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('81a239a2700addf2bfccfca1ee432dff', (getObjectProperty(___arguments.context.pageData, 'PagesListArray')));
    ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3014d1d4ba3a1b6fe2effd437e09e8c5', (getObjectProperty(___arguments.context.pageData, 'StudentsListArray')));
  } else {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Login', null);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/landing/components/255c1e2a0114c5220f333f3ec012c8f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var NewSurah, ww, item, Surah, j;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['from'] = null;
  ___arguments.context.pageData['to'] = null;
  Surah = (await (async () => {
    async function callback (item) {


      return ((item['SurahName']) == (___arguments.context.dataModel['surah_name']));
    }

    const list = await Promise.all((___arguments.context.pageData['SurahList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    const resultList = list.filter(item => item.value)

    return resultList.map(item => item.source)
  })())[0];
  if (Surah !== null && !Array.isArray(Surah) && (typeof Surah === 'object')) {
    var ww_list = (___arguments.context.dataModel['aya']);
    for (var ww_index in ww_list) {
      ww = ww_list[ww_index];
      if (!((ww['class']).indexOf('ALLREADYSAVED') !== -1)) {
        ww['class'] = (((ww['class']).includes('save')) ? ['unsave'] : []);
        await new Promise(r => setTimeout(r, 50 || 0));
      }
    }
    ___arguments.context.pageData['SurahList'] = (await (async () => {
      async function callback (item) {


        return ((item['SurahName']) != (___arguments.context.dataModel['surah_name']));
      }

      const list = await Promise.all((___arguments.context.pageData['SurahList']).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  } else {
    NewSurah = ({ 'SurahName': (___arguments.context.dataModel['surah_name']),'SelectedAyat': [] });
    var ww_list2 = (___arguments.context.dataModel['aya']);
    for (var ww_index2 in ww_list2) {
      ww = ww_list2[ww_index2];
      if (!((ww['class']).indexOf('ALLREADYSAVED') !== -1)) {
        ww['class'] = ['save'];
        await new Promise(r => setTimeout(r, 50 || 0));
        addItemToList((NewSurah['SelectedAyat']), ww);
      }
    }
    addItemToList((___arguments.context.pageData['SurahList']), NewSurah);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f8a9d0562364e21ceb28db61894fad95', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0cd4e5c17851a19d9a725c8d27119a18', true);
  }
  if ((___arguments.context.pageData['SurahList']).length == 0) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0cd4e5c17851a19d9a725c8d27119a18', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f8a9d0562364e21ceb28db61894fad95', true);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/413d63234328a629f798eaac06b94386/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var j, Surah, item;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((___arguments.context.dataModel['class']).indexOf('ALLREADYSAVED') !== -1)) {
    Surah = (await (async () => {
      async function callback (item) {


        return ((item['SurahName']) == (___arguments.context.getComponentDataStoreByUid('309fe2cc413f85dcf12e47a3d7886a43')['surah_name']));
      }

      const list = await Promise.all((___arguments.context.pageData['SurahList']).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })())[0];
    if ((___arguments.context.pageData['from']) == null) {
      if (Surah !== null && !Array.isArray(Surah) && (typeof Surah === 'object')) {
        console.log('obj');
        return ;
      }
      console.log('setting from');
      ___arguments.context.pageData['from'] = ({ 'Surah': (___arguments.context.getComponentDataStoreByUid('309fe2cc413f85dcf12e47a3d7886a43')['surah_name']),'Aya': (___arguments.context.dataModel['number_in_surah']) });
      ___arguments.context.dataModel['class'] = ['save'];
      addItemToList((___arguments.context.pageData['SurahList']), ({ 'SurahName': (___arguments.context.getComponentDataStoreByUid('309fe2cc413f85dcf12e47a3d7886a43')['surah_name']),'SelectedAyat': [] }));
    } else if ((___arguments.context.pageData['to']) == null) {
      if (((___arguments.context.pageData['from'])['Aya']) < (___arguments.context.dataModel['number_in_surah']) && ((___arguments.context.pageData['from'])['Surah']) == (___arguments.context.getComponentDataStoreByUid('309fe2cc413f85dcf12e47a3d7886a43')['surah_name'])) {
        console.log('setting to');
        ___arguments.context.pageData['to'] = ({ 'Surah': (___arguments.context.getComponentDataStoreByUid('309fe2cc413f85dcf12e47a3d7886a43')['surah_name']),'Aya': (___arguments.context.dataModel['number_in_surah']) });
        ___arguments.context.pageData['aya_to_save'] = [];
        Surah['SelectedAyat'] = (await Promise.all((await (async () => {
          async function callback (item) {


            return (((___arguments.context.pageData['from'])['Aya']) <= (item['number_in_surah']) && ((___arguments.context.pageData['to'])['Aya']) >= (item['number_in_surah']));
          }

          const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('309fe2cc413f85dcf12e47a3d7886a43')).map(async source => ({
            source,
            value: await callback(source),
          })));

          const resultList = list.filter(item => item.value)

          return resultList.map(item => item.source)
        })()).map(async item => {  item['class'] = ['save'];
        ; return item;})));
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f8a9d0562364e21ceb28db61894fad95', false);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0cd4e5c17851a19d9a725c8d27119a18', true);
      } else if (((___arguments.context.pageData['from'])['Aya']) == (___arguments.context.dataModel['number_in_surah'])) {
        console.log('reseting from');
        ___arguments.context.pageData['from'] = null;
        ___arguments.context.dataModel['class'] = ['unsave'];
        ___arguments.context.pageData['SurahList'] = (await (async () => {
          async function callback (item) {


            return ((Surah['SurahName']) != (___arguments.context.getComponentDataStoreByUid('309fe2cc413f85dcf12e47a3d7886a43')['surah_name']));
          }

          const list = await Promise.all((___arguments.context.pageData['SurahList']).map(async source => ({
            source,
            value: await callback(source),
          })));

          const resultList = list.filter(item => item.value)

          return resultList.map(item => item.source)
        })());
      }
    } else {
      ___arguments.context.pageData['to'] = null;
      ___arguments.context.pageData['from'] = null;
      ___arguments.context.pageData['SurahList'] = (await (async () => {
        async function callback (item) {


          return ((Surah['SurahName']) != (___arguments.context.getComponentDataStoreByUid('309fe2cc413f85dcf12e47a3d7886a43')['surah_name']));
        }

        const list = await Promise.all((___arguments.context.pageData['SurahList']).map(async source => ({
          source,
          value: await callback(source),
        })));

        const resultList = list.filter(item => item.value)

        return resultList.map(item => item.source)
      })());
      var j_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('309fe2cc413f85dcf12e47a3d7886a43'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if ((j['class']).indexOf('save') !== -1) {
          j['class'] = (((j['class']).includes('save')) ? ['unsave'] : []);
        }
      }
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0cd4e5c17851a19d9a725c8d27119a18', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f8a9d0562364e21ceb28db61894fad95', true);
    }
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      return (___arguments.context.dataModel['class']);

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/landing/components/2ea84a0db657860dd12534788006da53/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([' ',(___arguments.context.dataModel['aya_number_ar']),' '].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/landing/components/06135498409b7921c1dccd9dcfd45744/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var val;


  ___arguments.context.pageData['to'] = null;
  ___arguments.context.pageData['from'] = null;
  ___arguments.context.pageData['SurahList'] = [];
  val = (JSON.parse(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('81a239a2700addf2bfccfca1ee432dff'))));
  if (val != 1) {
    ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('81a239a2700addf2bfccfca1ee432dff', (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('81a239a2700addf2bfccfca1ee432dff')) - 1));
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ba088c7265f70b19b01bd70145e901a8', (await BackendlessUI.Functions.Custom['fn_a31967cfcdfc3278762b05fe92b4fc2f']((val - 1), ((___arguments.context.pageData['SelectedStudent'])['objectId']))));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/2f1d52c5bad7fce9a8e323550b2c2274/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var val;


  ___arguments.context.pageData['to'] = null;
  ___arguments.context.pageData['from'] = null;
  ___arguments.context.pageData['SurahList'] = [];
  val = (JSON.parse(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('81a239a2700addf2bfccfca1ee432dff'))));
  if (val != 604) {
    ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('81a239a2700addf2bfccfca1ee432dff', (val + 1));
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ba088c7265f70b19b01bd70145e901a8', (await BackendlessUI.Functions.Custom['fn_a31967cfcdfc3278762b05fe92b4fc2f']((val + 1), ((___arguments.context.pageData['SelectedStudent'])['objectId']))));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/81a239a2700addf2bfccfca1ee432dff/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ba088c7265f70b19b01bd70145e901a8', (await BackendlessUI.Functions.Custom['fn_a31967cfcdfc3278762b05fe92b4fc2f']((JSON.parse(___arguments.value)), ((___arguments.context.pageData['SelectedStudent'])['objectId']))));
  console.log(await BackendlessUI.Functions.Custom['fn_a31967cfcdfc3278762b05fe92b4fc2f']((JSON.parse(___arguments.value)), ((___arguments.context.pageData['SelectedStudent'])['objectId'])));

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/landing/components/1a582321333e24f5a9abc6c39c57e652/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if ((___arguments.context.dataModel['surah_name']) == 'سُورَةُ ٱلْفَاتِحَةِ' || (___arguments.context.dataModel['surah_name']) == 'سُورَةُ التَّوۡبَةِ') {
    return false;
  }
  if ((___arguments.context.dataModel['show']) == true) {
    return true;
  } else {
    return false;
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/landing/components/ec817181c908d01c6446bd786386ed7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')).indexOf('toggled') !== -1) {
    return (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')).pop());
  } else {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')), 'toggled');
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/f8a9d0562364e21ceb28db61894fad95/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')).indexOf('toggled') !== -1) {
    return (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')).pop());
  } else {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')), 'toggled');
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/0cd4e5c17851a19d9a725c8d27119a18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var j, student, item, students, savebutton, ayat, record, surah, list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1b54f4effd7d3411088fb9752d53cf41')).push('modal-show');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/179d7356ae4a7dc66f849ac268ea8d13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if ((___arguments.context.pageData['SelectedStudent']) !== null && !Array.isArray((___arguments.context.pageData['SelectedStudent'])) && (typeof (___arguments.context.pageData['SelectedStudent']) === 'object')) {
    return true;
  } else {
    return false;
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/landing/components/36f6853a2acfeddd14b4456fe0e84d47/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('2261661ba37b3dc646280c6925a70ccb')['LatestPage']) && (___arguments.context.getComponentDataStoreByUid('2261661ba37b3dc646280c6925a70ccb')['aya_number']) ? [' الصفحة رقم: ',(___arguments.context.getComponentDataStoreByUid('2261661ba37b3dc646280c6925a70ccb')['LatestPage']),'<br>',' آية ',(___arguments.context.getComponentDataStoreByUid('2261661ba37b3dc646280c6925a70ccb')['aya_number']),' من ',(___arguments.context.getComponentDataStoreByUid('2261661ba37b3dc646280c6925a70ccb')['surah_name'])].join('') : 'لم يتم تسجيل حفظ');

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/landing/components/6e124a0407f6795883b75eff11c5e4a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('حلقة ') + String(___arguments.context.dataModel['name']))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/landing/components/2261661ba37b3dc646280c6925a70ccb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var val;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['SelectedStudent'] = ___arguments.context.dataModel;
  ___arguments.context.pageData['CurrentPage'] = ((___arguments.context.pageData['SelectedStudent'])['LatestPage']);
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('81a239a2700addf2bfccfca1ee432dff', (___arguments.context.pageData['CurrentPage']));
  await new Promise(r => setTimeout(r, 100 || 0));
  val = (JSON.parse(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('81a239a2700addf2bfccfca1ee432dff'))));
  await new Promise(r => setTimeout(r, 100 || 0));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ba088c7265f70b19b01bd70145e901a8', (await BackendlessUI.Functions.Custom['fn_a31967cfcdfc3278762b05fe92b4fc2f'](val, ((___arguments.context.pageData['SelectedStudent'])['objectId']))));
  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')).indexOf('toggled') !== -1) {
    val = ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')).pop();
  } else {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')), 'toggled');
  }
  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('f128f741dbd53dadaa8c5c29bdcdfa8f')).indexOf('bottom-30') !== -1) {
    val = ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('f128f741dbd53dadaa8c5c29bdcdfa8f')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/47b614ea15b1cbf1bf0b97d1c734c0d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/8f1a7a3e51037b29759b1e1a9e6a4281/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if ((___arguments.context.pageData['SelectedStudent']) !== null && !Array.isArray((___arguments.context.pageData['SelectedStudent'])) && (typeof (___arguments.context.pageData['SelectedStudent']) === 'object')) {
    return false;
  } else {
    return true;
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/landing/components/ba088c7265f70b19b01bd70145e901a8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },  
  /* handler:onBeforeMount */
  /* handler:onBeforeUnmount */
  onBeforeUnmount(___arguments) {
    
  },  
  /* handler:onBeforeUnmount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ba088c7265f70b19b01bd70145e901a8')).length == 0) {
    return false;
  } else {
    return true;
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/landing/components/63584535a028988b130be82438080679/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var s;


  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ba088c7265f70b19b01bd70145e901a8')).length == 0) {
    return true;
  } else {
    return false;
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/landing/components/2a3f6bd80e014f44e1399208a11f2e2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var s;


  s = (___arguments.context.pageData['SelectedStudent']);
  if (!(typeof s === 'undefined')) {
    return ((s['LatestPage']) && (s['aya_number']) ? [' الصفحة رقم: ',(s['LatestPage']),'<br>',' آية ',(s['aya_number']),' من ',(s['surah_name'])].join('') : 'لم يتم تسجيل حفظ');
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/landing/components/92576c64c7696f38b0e9d95e08413031/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var j, student, item, students, savebutton, ayat, record, surah;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((___arguments.context.pageData['SelectedStudent']) !== null && !Array.isArray((___arguments.context.pageData['SelectedStudent'])) && (typeof (___arguments.context.pageData['SelectedStudent']) === 'object')) && ((___arguments.context.pageData['currentUser']) !== null && !Array.isArray((___arguments.context.pageData['currentUser'])) && (typeof (___arguments.context.pageData['currentUser']) === 'object')) && !(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('1e37af6639b6442370663ee140ac2ba1')) == '')) {
    savebutton = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('92576c64c7696f38b0e9d95e08413031'));
    savebutton['label'] = 'الرجاء الإنتظار....';
    savebutton['disabled'] = true;
    ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('87832d352fb942c8b932dc1366949f73'))['disabled'] = true;
    ayat = [];
    var surah_list = (___arguments.context.pageData['SurahList']);
    for (var surah_index in surah_list) {
      surah = surah_list[surah_index];
      addItemToList(ayat, (surah['SelectedAyat']));
    }
    record = (await Backendless.Data.of('SavingRecords').save( ({ 'ayat_total': ayat.length,'grade': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('1e37af6639b6442370663ee140ac2ba1')) }) ));
    if (record !== null && !Array.isArray(record) && (typeof record === 'object')) {
      await Backendless.Data.of('SavingRecords').setRelation(record, 'ByUser', [({ 'objectId': ((___arguments.context.pageData['currentUser'])['objectId']) })]);
      await Backendless.Data.of('SavingRecords').setRelation(record, 'ForStudent', [({ 'objectId': ((___arguments.context.pageData['SelectedStudent'])['objectId']) })]);
      await Backendless.Data.of('SavingRecords').setRelation(record, 'AyaLink', ayat);
      await Backendless.Messaging.publish('default', ({ 'ayat': ayat,'sex': ((___arguments.context.pageData['SelectedStudent'])['sex']),'name': ((___arguments.context.pageData['SelectedStudent'])['name']) }), new Backendless.PublishOptions({ subtopic: '', headers: ({ 'type': 'aya' }) }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
      if (ayat.length == 2) {
        await (async function() {
        	var name = (String('تمت اضافة آيتين بنجاح!'));


        	S.success(name);


        })();
      }
      if (ayat.length > 2) {
        await (async function() {
        	var name = (['تمت اضافة: ',ayat.length,'آيات بنجاح!'].join(''));


        	S.success(name);


        })();
      }
      await new Promise(r => setTimeout(r, 100 || 0));
      console.log(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1b54f4effd7d3411088fb9752d53cf41')).pop());
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('1e37af6639b6442370663ee140ac2ba1', '');
      await new Promise(r => setTimeout(r, 100 || 0));
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0cd4e5c17851a19d9a725c8d27119a18', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f8a9d0562364e21ceb28db61894fad95', true);
      ___arguments.context.pageData['to'] = null;
      ___arguments.context.pageData['from'] = null;
      ___arguments.context.pageData['SurahList'] = [];
      var item_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ba088c7265f70b19b01bd70145e901a8'));
      for (var item_index in item_list) {
        item = item_list[item_index];
        var j_list = (item['aya']);
        for (var j_index in j_list) {
          j = j_list[j_index];
          if ((j['class']).indexOf('save') !== -1) {
            j['class'] = (((j['class']).includes('save')) ? ['unsave', 'ALLREADYSAVED'] : []);
          }
        }
      }
    }
    savebutton['label'] = 'نعم';
    savebutton['disabled'] = false;
    ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('87832d352fb942c8b932dc1366949f73'))['disabled'] = false;
    students = ((___arguments.context.pageData['StudentsListArray']).map(item => item['students']))[0];
    student = (await (async () => {
      async function callback (item) {


        return (((___arguments.context.pageData['SelectedStudent'])['objectId']) == (item['objectId']));
      }

      const list = await Promise.all(students.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })())[0];
    await new Promise(r => setTimeout(r, 100 || 0));
    j = (await Backendless.Data.of('Student').findById((student['objectId']), Backendless.DataQueryBuilder.create().setProperties(['LatestPage', 'LatestAya.aya_number_ar as aya_number', 'LatestAya.Surah[aya_link].name as surah_name'])));
    student['aya_number'] = (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((j['aya_number'])))));
    student['LatestPage'] = (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((j['LatestPage'])))));
    student['surah_name'] = (j['surah_name']);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/87832d352fb942c8b932dc1366949f73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  return (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1b54f4effd7d3411088fb9752d53cf41')).pop());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/landing/components/d63ff6c5074b48b1bb4b17def60a812e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ba088c7265f70b19b01bd70145e901a8')).length == 0) {
    return true;
  } else {
    return false;
  }

  },  
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (((___arguments.context.pageData['currentUser']) !== null && !Array.isArray((___arguments.context.pageData['currentUser'])) && (typeof (___arguments.context.pageData['currentUser']) === 'object')) ? String('مرحباَ, ') + String((___arguments.context.pageData['currentUser'])['name']) : null)

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/map/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var arr, comps, error, in2, j, user_loc;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  user_loc = (await ( async function (){ return new Promise((resolve,reject) => navigator.geolocation.getCurrentPosition(p => resolve({ lat: p.coords.latitude, lng: p.coords.longitude }), e => reject(e) )) })());
  if (user_loc !== null && !Array.isArray(user_loc) && (typeof user_loc === 'object')) {
    try {
      ;(function (componentUid, lat, lng){ ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('51b9132d47a5aeb52d1278b10f08dff8', 25.234044, 45.252789);
      arr = [];
      ___arguments.context.pageData['comps'] = arr;
      in2 = 0;
      ;(function (componentUid, points){ ___arguments.context.getComponentByUid(componentUid).points = points })('51b9132d47a5aeb52d1278b10f08dff8', arr);
      comps = (await Backendless.Data.of('comp').find(Backendless.DataQueryBuilder.create().setWhereClause('not location is null').setProperties(['name', 'location', ['distanceOnSphere(location, \'POINT(',(user_loc['lng']),' ',(user_loc['lat']),')\') as distance'].join(''), 'photo', 'info', 'objectId', 'sex']).setPageSize(100)));
      if (comps.length > 0) {
        for (var j_index in comps) {
          j = comps[j_index];
          addItemToList(arr, ({ 'objectId': (j['objectId']),'name': (j['name']),'lat': ((j['location'])['lat']),'lng': ((j['location'])['lng']),'distance': String(Math.round((j['distance']) / 1000)) + String(' كم'),'info': (j['info']),'photo': (j['photo']),'sex': (j['sex']) }));
          ___arguments.context.pageData['totals'] = (['<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((arr.length))))),'</b> ','مجمع ودار'].join(''));
          await new Promise(r => setTimeout(r, 100 || 0));
        }
      } else {
      }

    } catch (error) {
      console.log(error);

    }
  } else {
    ;await ( async function (message){ alert(message) })('');
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/map/components/51b9132d47a5aeb52d1278b10f08dff8/bundle.js', [], () => ({
  /* content */
  /* handler:onMarkerClick */
  async onMarkerClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.point['students'] = (await Backendless.Data.of('Student').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['circle_link.comp[circle_link].objectId=\'',(___arguments.point['objectId']),'\''].join('')))));
  ___arguments.point['teachers'] = (await Backendless.Data.of('Users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['circle[user_link].comp[circle_link].objectId=\'',(___arguments.point['objectId']),'\''].join('')))));
  ___arguments.point['circles'] = (await Backendless.Data.of('circle').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['comp[circle_link].objectId=\'',(___arguments.point['objectId']),'\''].join('')))));
  ___arguments.context.pageData['Selected'] = ___arguments.point;
  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('557e5a0b61c2ebadd8e986c6f179baea')), 'modal-show');

  },  
  /* handler:onMarkerClick */
  /* content */
}))

define('./pages/map/components/a22ba9c783dd2d46a099713f534dd62a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  return (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('557e5a0b61c2ebadd8e986c6f179baea')).pop());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/map/components/e797573b176bc1775b41f77577ef817c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((___arguments.context.pageData['Selected']) ? ['يبعد عنك ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5'](((___arguments.context.pageData['Selected'])['distance']))),' </b>','يتدارس فيه القرآن ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify(((___arguments.context.pageData['Selected'])['students']))))),' </b>','طالب. على يد ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify(((___arguments.context.pageData['Selected'])['teachers']))))),' </b>','معلمين. موزعين في ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify(((___arguments.context.pageData['Selected'])['circles']))))),' </b>','حلقات.'].join('') : ' ')

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/map/components/a7af4e5c740cfcb760a8bd1546723e15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://www.google.com/maps/dir/', true, ({ 'api': '1','destination': [((___arguments.context.pageData['Selected'])['lat']),',',((___arguments.context.pageData['Selected'])['lng'])].join('') }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/map/components/50451ee34993856eb915f14dfd84a582/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var in2, item;


  ___arguments.context.pageData['sex'] = 'بنين';
  in2 = (await (async () => {
    async function callback (item) {


      return ((item['sex']) == 'بنين');
    }

    const list = await Promise.all((___arguments.context.pageData['comps']).map(async source => ({
      source,
      value: await callback(source),
    })));

    const resultList = list.filter(item => item.value)

    return resultList.map(item => item.source)
  })());
  ;(function (componentUid, points){ ___arguments.context.getComponentByUid(componentUid).points = points })('51b9132d47a5aeb52d1278b10f08dff8', in2);
  ___arguments.context.pageData['totals'] = (['<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((in2.length))))),'</b> ','مجمعات'].join(''));

  },  
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      if ('بنين' == (___arguments.context.pageData['sex'])) {
    return true;
  }

  },  
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/map/components/7d897524a0c4c2c9968a913e70fc8741/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var in2, item;


  try {
    ___arguments.context.pageData['sex'] = 'بنات';
    in2 = (await (async () => {
      async function callback (item) {


        return ((item['sex']) == 'بنات');
      }

      const list = await Promise.all((___arguments.context.pageData['comps']).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
    ;(function (componentUid, points){ ___arguments.context.getComponentByUid(componentUid).points = points })('51b9132d47a5aeb52d1278b10f08dff8', in2);
    ___arguments.context.pageData['totals'] = (['<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((in2.length))))),'</b> ','دور نسائية'].join(''));

  } catch (error) {

  }

  },  
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      if ('بنات' == (___arguments.context.pageData['sex'])) {
    return true;
  }

  },  
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/map/components/a5f2d193a724e139f065f3f310dcf648/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var in2;


  try {
    ___arguments.context.pageData['sex'] = 'الكل';
    in2 = (___arguments.context.pageData['comps']);
    ;(function (componentUid, points){ ___arguments.context.getComponentByUid(componentUid).points = points })('51b9132d47a5aeb52d1278b10f08dff8', in2);
    ___arguments.context.pageData['totals'] = (['<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((in2.length))))),'</b> ','مجمع ودار'].join(''));

  } catch (error) {

  }

  },  
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      if ('الكل' == (___arguments.context.pageData['sex'])) {
    return true;
  }

  },  
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/map/components/a1bf53b687a612ac652dc911db2f8c5d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    var j, obj, arr, comps, in2;

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/map/components/c08f8d6ff8f7598c1594a0ee5cd60681/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var in2, item;


  if (typeof (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a1bf53b687a612ac652dc911db2f8c5d'))['value']) === 'string') {
    ___arguments.context.pageData['Disabled'] = true;
    ___arguments.context.pageData['sex'] = 'الكل';
    in2 = (await (async () => {
      async function callback (item) {


        return ((item['name']).indexOf((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a1bf53b687a612ac652dc911db2f8c5d'))['value'])) !== -1);
      }

      const list = await Promise.all((___arguments.context.pageData['comps']).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
    ;(function (componentUid, points){ ___arguments.context.getComponentByUid(componentUid).points = points })('51b9132d47a5aeb52d1278b10f08dff8', in2);
    ___arguments.context.pageData['totals'] = (['<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((in2.length))))),'</b> ','مجمع/دار'].join(''));
    ___arguments.context.pageData['Disabled'] = false;
    ;(function (componentUid, lat, lng){ ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('51b9132d47a5aeb52d1278b10f08dff8', ((in2[0])['lat']), ((in2[0])['lng']));
    if (in2.length == 1) {
      ;(function (componentUid, marker, popupContent){ ___arguments.context.getComponentByUid(componentUid).map.showInfoWindow(marker, { content: popupContent }) })('51b9132d47a5aeb52d1278b10f08dff8', (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).map.markers })('51b9132d47a5aeb52d1278b10f08dff8'))[0]), ((in2[0])['name']));
      ;(function (componentUid, lat, lng){ ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('51b9132d47a5aeb52d1278b10f08dff8', ((in2[0])['lat']), ((in2[0])['lng']));
    }
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/overall/components/f74a61674c7e734d4f9511232fbe2cd7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}


  console.log('cell logic executed');
  if ((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['sex']) == 'بنين') {
    return (['اتم حفظ : ','<b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']),'</b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']) <= 10 ? ' آيات ' : ' آيه ',listsGetRandomItem([' بارك الله فيه ', ' اثابه الله ', ' وفقه الله '], false)].join(''));
  } else {
    return (['اتمت حفظ : ','<b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']),'</b>',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['totals']) <= 10 ? ' آيات ' : ' آيه ',listsGetRandomItem([' بارك الله فيها ', ' اثابها الله', ' وفقها الله '], false)].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/overall/components/e37c3a4b3f5d507bba4a9c52e29a83fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['comp_name']),' في حلقة ',(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['circle_name'])].join(''));

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/overall/components/c2ec81484eb37de13004149e1919d872/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
    var ayat_total, error;

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/overall/components/4f22737d1387d729a1ec290d4a589708/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
    var ayat_total, error;

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/overall/components/2ad2bc3ae6e8e3687a99992d205ff9a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c775ed9a5d6615a1292b2917c256a7de'))['height'] = '100%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overall/components/78b5ff541f855147128abd824a96e589/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c775ed9a5d6615a1292b2917c256a7de'))['height'] = '0';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overall/components/7edbe549ba6ce3e92b89f36d73e88a5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var current_month;


  current_month = [(new Date((new Date())).getMonth()) + 1 >= 10 ? (new Date((new Date())).getMonth()) + 1 : String(0) + String((new Date((new Date())).getMonth()) + 1),'/01/',(new Date((new Date())).getFullYear())].join('');

  return (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['created_month >= \'',current_month,'\''].join(''))).setProperties(['count(objectId) as totals', 'ByUser.name as name', 'ByUser.circle[user_link].name as circle_name', 'ByUser.circle[user_link].comp[circle_link].name as comp_name', 'ByUser.photo as pic', 'ByUser.objectId as id', 'ByUser.sex as sex']).setSortBy('totals desc').setGroupBy('id').setPageSize(4)))

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/overall/components/a49f55faf65db9a32926feec78f91ee9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}


  if ((___arguments.context.getComponentDataStoreByUid('93bd7ac7b98431938278bb31b309eea7')['sex']) == 'بنين') {
    return (['اتم ادخال: ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('93bd7ac7b98431938278bb31b309eea7')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('93bd7ac7b98431938278bb31b309eea7')['totals']) <= 10 ? '  عمليات ' : ' عملية ',listsGetRandomItem([' بارك الله فيه ', ' اثابه الله ', ' وفقه الله '], false)].join(''));
  } else {
    return (['اتمت ادخال: ','<b>',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('93bd7ac7b98431938278bb31b309eea7')['totals']))))),'</b>',(___arguments.context.getComponentDataStoreByUid('93bd7ac7b98431938278bb31b309eea7')['totals']) <= 10 ? '  عمليات ' : ' عملية ',listsGetRandomItem([' بارك الله فيها ', ' اثابها الله ', ' وفقها الله '], false)].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/overall/components/40c350f2886c0363d08257e3a34bc328/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('comps', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/overall/components/93f581fa0c87433df8a31caa0ba3ff4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('comps_girls', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/overall/components/96bb5a93a43384ffb0997d5a89b744a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('student_detail', ({ 'student': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647'), 'id')),'name': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647'), 'name')),'sex': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647'), 'sex')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overall/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onLeave */
  onLeave(___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getRTSubscriptions() { const subs = getGlobalEntitiesMap('subscriptions');subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`RT subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}


  getRTSubscriptions().remove('RT_aya');;
  getRTSubscriptions().remove('RT_page');;
  getRTSubscriptions().remove('RT_surah');;
  getRTSubscriptions().remove('RT_juza');;

  },  
  /* handler:onLeave */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var message, rt, ayat_total_female, ayat_total_male, ayat_total;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  ___arguments.context.pageData['zeroTime'] = '\'08/20/2024\'';
  ayat_total = (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((String('created > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))).setProperties(['sum (AyaLink.letters_count) as letters_count', 'sum (AyaLink.words_count) as words_count', 'count (AyaLink) as aya_count']).setPageSize(1)))[0];
  ayat_total_male = (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((String('ForStudent.sex=\'بنين\' AND created > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))).setProperties(['sum (AyaLink.letters_count) as letters_count', 'sum (AyaLink.words_count) as words_count', 'count (AyaLink) as aya_count']).setPageSize(1)))[0];
  ayat_total_female = (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((String('ForStudent.sex=\'بنات\' AND created >') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))).setProperties(['sum (AyaLink.letters_count) as letters_count', 'sum (AyaLink.words_count) as words_count', 'count (AyaLink) as aya_count']).setPageSize(1)))[0];
  await (async function(aya, word, letter, juza_count, sura_count, page_count, aya_male, word_male, letter_male, juza_count_male, sura_count_male, page_count_male, aya_female, word_female, letter_female, juza_count_female, sura_count_female, page_count_female) {
  	C = await BackendlessUI.requireModule('https://app.m7l-e.com/A7FE1705-BFF3-D2D4-FF46-462570D69D00/18B970E9-399B-4BCF-8669-9B66CFD1E9D6/files/count-up/countUp.js');
  	//J = await BackendlessUI.requireModule('https://code.jquery.com/jquery-3.6.0.min.js');
  	S = await BackendlessUI.requireModule('https://app.m7l-e.com/A7FE1705-BFF3-D2D4-FF46-462570D69D00/18B970E9-399B-4BCF-8669-9B66CFD1E9D6/files/alert/alertify.min.js');

  	const options = {
  	duration: 50,
  	numerals: ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'],
  	};

  	Window.current_aya = aya;
  	Window.current_word = word;
  	Window.current_letter = letter;
  	Window.current_juza = juza_count;
  	Window.current_sura = sura_count;
  	Window.current_page = page_count;

  	Window.ayat = new C.CountUp('main_aya_block', Window.current_aya,options);
  	Window.ayat.start()

  	Window.words = new C.CountUp('main_word_block', Window.current_word,options);
  	Window.words.start()

  	Window.letters = new C.CountUp('main_letter_block', Window.current_letter,options);
  	Window.letters.start()

  	Window.juza = new C.CountUp('main_juza_block', Window.current_juza,options);
  	Window.juza.start()

  	Window.sura = new C.CountUp('main_sura_block', Window.current_sura,options);
  	Window.sura.start()

  	Window.page = new C.CountUp('main_page_block', Window.current_page,options);
  	Window.page.start()


  	Window.current_aya_male = aya_male;
  	Window.current_word_male = word_male;
  	Window.current_letter_male = letter_male;
  	Window.current_juza_male = juza_count_male;
  	Window.current_sura_male = sura_count_male;
  	Window.current_page_male = page_count_male;

  	Window.ayat_male = new C.CountUp('main_aya_block_male', Window.current_aya_male,options);
  	Window.ayat_male.start()

  	Window.words_male = new C.CountUp('main_word_block_male', Window.current_word_male,options);
  	Window.words_male.start()

  	Window.letters_male = new C.CountUp('main_letter_block_male', Window.current_letter_male,options);
  	Window.letters_male.start()

  	Window.juza_male = new C.CountUp('main_juza_block_male', Window.current_juza_male,options);
  	Window.juza_male.start()

  	Window.sura_male = new C.CountUp('main_sura_block_male', Window.current_sura_male,options);
  	Window.sura_male.start()

  	Window.page_male = new C.CountUp('main_page_block_male', Window.current_page_male,options);
  	Window.page_male.start()



  	Window.current_aya_female = aya_female;
  	Window.current_word_female = word_female;
  	Window.current_letter_female = letter_female;
  	Window.current_juza_female = juza_count_female;
  	Window.current_sura_female = sura_count_female;
  	Window.current_page_female = page_count_female;

  	Window.ayat_female = new C.CountUp('main_aya_block_female', Window.current_aya_female,options);
  	Window.ayat_female.start()

  	Window.words_female = new C.CountUp('main_word_block_female', Window.current_word_female,options);
  	Window.words_female.start()

  	Window.letters_female = new C.CountUp('main_letter_block_female', Window.current_letter_female,options);
  	Window.letters_female.start()

  	Window.juza_female = new C.CountUp('main_juza_block_female', Window.current_juza_female,options);
  	Window.juza_female.start()

  	Window.sura_female = new C.CountUp('main_sura_block_female', Window.current_sura_female,options);
  	Window.sura_female.start()

  	Window.page_female = new C.CountUp('main_page_block_female', Window.current_page_female,options);
  	Window.page_female.start()



  	S.defaults = {
  	        // dialogs defaults
  	        autoReset:true,
  	        basic:false,
  	        closable:true,
  	        closableByDimmer:true,
  	        invokeOnCloseOff:false,
  	        frameless:false,
  	        defaultFocusOff:false,
  	        maintainFocus:true, // <== global default not per instance, applies to all dialogs
  	        maximizable:true,
  	        modal:true,
  	        movable:true,
  	        moveBounded:false,
  	        overflow:true,
  	        padding: true,
  	        pinnable:true,
  	        pinned:true,
  	        preventBodyShift:false, // <== global default not per instance, applies to all dialogs
  	        resizable:true,
  	        startMaximized:false,
  	        transition:'pulse',
  	        transitionOff:false,
  	        tabbable:'button:not(:disabled):not(.ajs-reset),[href]:not(:disabled):not(.ajs-reset),input:not(:disabled):not(.ajs-reset),select:not(:disabled):not(.ajs-reset),textarea:not(:disabled):not(.ajs-reset),[tabindex]:not([tabindex^="-"]):not(:disabled):not(.ajs-reset)',  // <== global default not per instance, applies to all dialogs

  	        // notifier defaults
  	        notifier:{
  	        // auto-dismiss wait time (in seconds)
  	            delay:15,
  	        // default position
  	            position:'top-left',
  	        // adds a close button to notifier messages
  	            closeButton: false,
  	        // provides the ability to rename notifier classes
  	            classes : {
  	                base: 'alertify-notifier',
  	                prefix:'ajs-',
  	                message: 'ajs-message',
  	                top: 'ajs-top',
  	                right: 'ajs-right',
  	                bottom: 'ajs-bottom',
  	                left: 'ajs-left',
  	                center: 'ajs-center',
  	                visible: 'ajs-visible',
  	                hidden: 'ajs-hidden',
  	                close: 'ajs-close'
  	            }
  	        },

  	        // language resources
  	        glossary:{
  	            // dialogs default title
  	            title:'اشعار',
  	            // ok button text
  	            ok: 'موافق',
  	            // cancel button text
  	            cancel: 'الغاء'
  	        },

  	        // theme settings
  	        theme:{
  	            // class name attached to prompt dialog input textbox.
  	            input:'ajs-input',
  	            // class name attached to ok button
  	            ok:'ajs-ok',
  	            // class name attached to cancel button
  	            cancel:'ajs-cancel'
  	        },
  	        // global hooks
  	        hooks:{
  	            // invoked before initializing any dialog
  	            preinit:function(instance){},
  	            // invoked after initializing any dialog
  	            postinit:function(instance){},
  	        },
  	    };



  })((getObjectProperty(ayat_total, 'aya_count')), (getObjectProperty(ayat_total, 'words_count')), (getObjectProperty(ayat_total, 'letters_count')), (await Backendless.Data.of('juza_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('per=100 AND updated > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))))), (await Backendless.Data.of('surah_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('per=100 AND updated > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))))), (await Backendless.Data.of('page_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('per=100 AND updated > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))))), (getObjectProperty(ayat_total_male, 'aya_count')), (getObjectProperty(ayat_total_male, 'words_count')), (getObjectProperty(ayat_total_male, 'letters_count')), (await Backendless.Data.of('juza_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('per=100 and student_link.sex=\'بنين\' AND updated > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))))), (await Backendless.Data.of('surah_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('per=100 and student_link.sex=\'بنين\' AND updated > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))))), (await Backendless.Data.of('page_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('per=100 and student_link.sex=\'بنين\' AND updated > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))))), (getObjectProperty(ayat_total_female, 'aya_count')), (getObjectProperty(ayat_total_female, 'words_count')), (getObjectProperty(ayat_total_female, 'letters_count')), (await Backendless.Data.of('juza_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('per=100 and student_link.sex=\'بنات\' AND updated > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))))), (await Backendless.Data.of('surah_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('per=100 and student_link.sex=\'بنات\' AND updated > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))))), (await Backendless.Data.of('page_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('per=100 and student_link.sex=\'بنات\' AND updated > ') + String(getObjectProperty(___arguments.context.pageData, 'zeroTime')))))));

  ;(function(selector) {
    const callback = async message => {
        rt = (await Backendless.Data.of('Aya').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId in (\'',((getObjectProperty((getObjectProperty(message, 'message')), 'ayat')).map(item => item['objectId'])).join('\',\''),'\') '].join(''))).setProperties(['sum (letters_count) as new_letters', 'sum (words_count) as new_words']).setPageSize(10)))[0];
    await (async function(name, sex, words_count, letters_count, total) {
    	if(sex == 'بنين'){
    	S.success('الطالب '+name+' اتم حفظ '+total+' ايات ');

    	Window.current_aya_male += total;
    	Window.current_word_male += words_count;
    	Window.current_letter_male += letters_count;

    	Window.ayat_male.update(Window.current_aya_male);
    	Window.words_male.update(Window.current_word_male);
    	Window.letters_male.update(Window.current_letter_male);
    	}
    	if(sex == 'بنات'){
    	S.success('الطالبة '+name+' اتمت حفظ '+total+' ايات ');

    	Window.current_aya_female += total;
    	Window.current_word_female += words_count;
    	Window.current_letter_female += letters_count;

    	Window.ayat_female.update(Window.current_aya_female);
    	Window.words_female.update(Window.current_word_female);
    	Window.letters_female.update(Window.current_letter_female);

    	}

    	Window.current_aya += total;
    	Window.current_word += words_count;
    	Window.current_letter += letters_count;

    	Window.ayat.update(Window.current_aya);
    	Window.words.update(Window.current_word);
    	Window.letters.update(Window.current_letter);
    })((getObjectProperty((getObjectProperty(message, 'message')), 'name')), (getObjectProperty((getObjectProperty(message, 'message')), 'sex')), (getObjectProperty(rt, 'new_words')), (getObjectProperty(rt, 'new_letters')), ((getObjectProperty((getObjectProperty(message, 'message')), 'ayat')).length));

    };

    const channel = getChannelInstance('default');

    const options = [callback];

    if (selector) {
       options.unshift(selector);
    }

    channel.addMessageListener.apply(channel, options);

    getRTSubscriptions().add('RT_aya', () => channel.removeMessageListener.apply(channel, options));
  })('type=\'aya\'');

  ;(function(selector) {
    const callback = async message => {
        await (async function(name, sex, number) {
    	if(sex == 'بنين'){
    	S.success('الطالب '+name+
    	' اتم حفظ الوجه رقم '
    	+ number);

    	Window.current_page_male += 1;
    	Window.page_male.update(Window.current_page_male);

    	}
    	if(sex == 'بنات'){
    	S.success('الطالبة '+name+
    	' اتمت حفظ الوجه رقم '
    	+ number);

    	Window.current_page_female += 1;
    	Window.page_female.update(Window.current_page_female);

    	}

    	Window.current_page += 1;
    	Window.page.update(Window.current_page);

    })((getObjectProperty((getObjectProperty(message, 'message')), 'name')), (getObjectProperty((getObjectProperty(message, 'message')), 'sex')), (getObjectProperty((getObjectProperty(message, 'message')), 'page')));

    };

    const channel = getChannelInstance('default');

    const options = [callback];

    if (selector) {
       options.unshift(selector);
    }

    channel.addMessageListener.apply(channel, options);

    getRTSubscriptions().add('RT_page', () => channel.removeMessageListener.apply(channel, options));
  })('type=\'page\'');

  ;(function(selector) {
    const callback = async message => {
        console.log(message);
    await (async function(name, sex, surah_name) {
    	if(sex == 'بنين'){
    	S.success('الطالب '+name+
    	' اتم حفظ '
    	+ surah_name);

    	Window.current_sura_male += 1;
    	Window.sura_male.update(Window.current_sura_male);

    	}
    	if(sex == 'بنات'){
    	S.success('الطالبة '+name+
    	' اتمت حفظ '
    	+ surah_name);

    	Window.current_sura_female += 1;
    	Window.sura_female.update(Window.current_sura_female);

    	}


    	Window.current_sura += 1;
    	Window.sura.update(Window.current_sura);

    })((getObjectProperty((getObjectProperty(message, 'message')), 'name')), (getObjectProperty((getObjectProperty(message, 'message')), 'sex')), (getObjectProperty((getObjectProperty(message, 'message')), 'surah')));

    };

    const channel = getChannelInstance('default');

    const options = [callback];

    if (selector) {
       options.unshift(selector);
    }

    channel.addMessageListener.apply(channel, options);

    getRTSubscriptions().add('RT_surah', () => channel.removeMessageListener.apply(channel, options));
  })('type=\'surah\'');

  ;(function(selector) {
    const callback = async message => {
        console.log(message);
    await (async function(name, sex, number) {

    	if(sex == 'بنين'){
    	S.success('الطالب '+name+
    	' اتم حفظ الجزء رقم '
    	+ number);

    	Window.current_juza_male += 1;
    	Window.juza_male.update(Window.current_juza_male);

    	}
    	if(sex == 'بنات'){
    	S.success('الطالبة '+name+
    	' اتمت حفظ الجزء رقم '
    	+ number);

    	Window.current_juza_female += 1;
    	Window.juza_female.update(Window.current_juza_female);

    	}
    	Window.current_juza += 1;
    	Window.juza.update(Window.current_juza);

    })((getObjectProperty((getObjectProperty(message, 'message')), 'name')), (getObjectProperty((getObjectProperty(message, 'message')), 'sex')), (getObjectProperty((getObjectProperty(message, 'message')), 'juza')));

    };

    const channel = getChannelInstance('default');

    const options = [callback];

    if (selector) {
       options.unshift(selector);
    }

    channel.addMessageListener.apply(channel, options);

    getRTSubscriptions().add('RT_juza', () => channel.removeMessageListener.apply(channel, options));
  })('type=\'juza\'');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/overall/components/fc9bb424d2ff25fba187983360cfb56b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var current_month;


  console.log('row logic executed');
  current_month = [(new Date((new Date())).getMonth()) + 1 >= 10 ? (new Date((new Date())).getMonth()) + 1 : String(0) + String((new Date((new Date())).getMonth()) + 1),'/01/',(new Date((new Date())).getFullYear())].join('');
  ___arguments.context.dataModel['items'] = (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['created_month >= \'',current_month,'\''].join(''))).setProperties(['sum(ayat_total) as totals', 'ForStudent.name as name', 'ForStudent.circle_link.name as circle_name', 'ForStudent.circle_link.comp[circle_link].name as comp_name', 'ForStudent.pic as pic', 'ForStudent.objectId as id', 'ForStudent.sex']).setSortBy('totals desc').setGroupBy('id').setPageSize(4)));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overall/components/c328f6f848ad05ee78279ff7e627c981/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quran/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      ___arguments.context.pageData['playing'] = false;
  await (async function() {
  	var sound = document.createElement('audio');
  	sound.id = 'audio-player';
  	document.body.appendChild(sound);
  })();
  if (!(Array.isArray(((function(){ try { return JSON.parse(localStorage.getItem('BookMarks')) } catch(e){ return null }})())))) {
    localStorage.setItem('BookMarks', JSON.stringify([]));
    ___arguments.context.pageData['BookMarks'] = ((function(){ try { return JSON.parse(localStorage.getItem('BookMarks')) } catch(e){ return null }})());
  } else {
    ___arguments.context.pageData['BookMarks'] = ((function(){ try { return JSON.parse(localStorage.getItem('BookMarks')) } catch(e){ return null }})());
  }
  ___arguments.context.pageData['PagesListArray'] = (((await Backendless.Data.of('PageSelectJSON').find(Backendless.DataQueryBuilder.create().setProperties(['json']).setPageSize(1)))[0])['json']);
  ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('81a239a2700addf2bfccfca1ee432dff', (___arguments.context.pageData['PagesListArray']));
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('81a239a2700addf2bfccfca1ee432dff', 1);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ba088c7265f70b19b01bd70145e901a8', (await BackendlessUI.Functions.Custom['fn_a31967cfcdfc3278762b05fe92b4fc2f'](1, null)));
  await (async function() {

  })();

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/quran/components/255c1e2a0114c5220f333f3ec012c8f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var NewSurah, ww, item, Surah;

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/quran/components/413d63234328a629f798eaac06b94386/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var ayat, surah, item;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (!((___arguments.context.pageData['Selected']) !== null && !Array.isArray((___arguments.context.pageData['Selected'])) && (typeof (___arguments.context.pageData['Selected']) === 'object'))) {
    ___arguments.context.pageData['Selected'] = ___arguments.context.dataModel;
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('413d63234328a629f798eaac06b94386')), 'save');
  } else {
    ___arguments.context.pageData['Selected'] = null;
    removeItemInList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('413d63234328a629f798eaac06b94386')), 'save', '=');
    var surah_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ba088c7265f70b19b01bd70145e901a8'));
    for (var surah_index in surah_list) {
      surah = surah_list[surah_index];
      surah = (await (async () => {
        async function callback (item) {


          return ((item['class']).indexOf('save') + 1);
        }

        const list = await Promise.all((surah['aya']).map(async source => ({
          source,
          value: await callback(source),
        })));

        const resultList = list.filter(item => item.value)

        return resultList.map(item => item.source)
      })());
    }
    for (var ayat_index in surah) {
      ayat = surah[ayat_index];
      ayat['class'] = [];
    }
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/quran/components/2ea84a0db657860dd12534788006da53/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([' ',(___arguments.context.dataModel['aya_number_ar']),' '].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/quran/components/06135498409b7921c1dccd9dcfd45744/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var val;


  ___arguments.context.pageData['Selected'] = null;
  ___arguments.context.pageData['SurahList'] = [];
  val = (JSON.parse(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('81a239a2700addf2bfccfca1ee432dff'))));
  if (val != 1) {
    console.log((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('81a239a2700addf2bfccfca1ee432dff'));
    ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('81a239a2700addf2bfccfca1ee432dff', (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('81a239a2700addf2bfccfca1ee432dff')) - 1));
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ba088c7265f70b19b01bd70145e901a8', (await BackendlessUI.Functions.Custom['fn_a31967cfcdfc3278762b05fe92b4fc2f']((val - 1))));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/quran/components/2f1d52c5bad7fce9a8e323550b2c2274/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var val;


  ___arguments.context.pageData['Selected'] = null;
  ___arguments.context.pageData['SurahList'] = [];
  val = (JSON.parse(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('81a239a2700addf2bfccfca1ee432dff'))));
  if (val != 604) {
    ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('81a239a2700addf2bfccfca1ee432dff', (val + 1));
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ba088c7265f70b19b01bd70145e901a8', (await BackendlessUI.Functions.Custom['fn_a31967cfcdfc3278762b05fe92b4fc2f']((val + 1))));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/quran/components/81a239a2700addf2bfccfca1ee432dff/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var s;


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ba088c7265f70b19b01bd70145e901a8', (await BackendlessUI.Functions.Custom['fn_a31967cfcdfc3278762b05fe92b4fc2f']((JSON.parse(___arguments.value)))));

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/quran/components/1a582321333e24f5a9abc6c39c57e652/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if ((___arguments.context.dataModel['surah_name']) == 'سُورَةُ ٱلْفَاتِحَةِ' || (___arguments.context.dataModel['surah_name']) == 'سُورَةُ التَّوۡبَةِ') {
    return false;
  }
  if ((___arguments.context.dataModel['show']) == true) {
    return true;
  } else {
    return false;
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/quran/components/ec817181c908d01c6446bd786386ed7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')).indexOf('toggled') !== -1) {
    return (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')).pop());
  } else {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')), 'toggled');
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/quran/components/f8a9d0562364e21ceb28db61894fad95/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')).indexOf('toggled') !== -1) {
    return (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')).pop());
  } else {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')), 'toggled');
    ___arguments.context.pageData['Tfseer'] = ((((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://api.quran.com/api/v4/quran/tafsirs/90?verse_key=',((___arguments.context.pageData['Selected'])['surah_number']),':',((___arguments.context.pageData['Selected'])['number_in_surah'])].join('')))).setEncoding('utf8').send())['tafsirs'])[0])['text']);
  }

  },  
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      if ((___arguments.context.pageData['Selected']) !== null && !Array.isArray((___arguments.context.pageData['Selected'])) && (typeof (___arguments.context.pageData['Selected']) === 'object')) {
    return false;
  } else {
    return true;
  }

  },  
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/quran/components/0cd4e5c17851a19d9a725c8d27119a18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.pageData['playing']) == false) {
    if ((___arguments.context.pageData['Selected']) !== null && !Array.isArray((___arguments.context.pageData['Selected'])) && (typeof (___arguments.context.pageData['Selected']) === 'object')) {
      await (async function() {
      	var sound = (['https://cdn.islamic.network/quran/audio/64/','ar.abdulbasitmurattal','/',((___arguments.context.pageData['Selected'])['aya_number']),'.mp3'].join(''));

      	var audio_sound = document.getElementById("audio-player");
      	audio_sound.src=sound;
      	audio_sound.play();

      })();
      ___arguments.context.pageData['playing'] = true;
      console.log(___arguments.context.pageData['playing']);
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0cd4e5c17851a19d9a725c8d27119a18'))['label'] = 'ايقاف';
      console.log('abc');
    }
  } else if ((___arguments.context.pageData['playing']) == true) {
    ___arguments.context.pageData['playing'] = false;
    await (async function() {
    	var audio_sound = document.getElementById("audio-player");
    	audio_sound.src='';
    })();
    console.log(___arguments.context.pageData['playing']);
    ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0cd4e5c17851a19d9a725c8d27119a18'))['label'] = 'قراءة';
  }

  },  
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      if ((___arguments.context.pageData['Selected']) !== null && !Array.isArray((___arguments.context.pageData['Selected'])) && (typeof (___arguments.context.pageData['Selected']) === 'object')) {
    return false;
  } else {
    return true;
  }

  },  
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/quran/components/ba088c7265f70b19b01bd70145e901a8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },  
  /* handler:onBeforeMount */
  /* handler:onBeforeUnmount */
  onBeforeUnmount(___arguments) {
    
  },  
  /* handler:onBeforeUnmount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ba088c7265f70b19b01bd70145e901a8')).length == 0) {
    return false;
  } else {
    return true;
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/quran/components/6e8ea48c5d6b081b84383244e8a72ea4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;


  if ((await (async () => {
    async function callback (item) {


      return ((item['id']) == ((___arguments.context.pageData['Selected'])['objectId']));
    }

    const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a439583307cd30abe3825cfe51dfb0e2')).map(async source => ({
      source,
      value: await callback(source),
    })));

    const resultList = list.filter(item => item.value)

    return resultList.map(item => item.source)
  })()).length == 0) {
    (___arguments.context.pageData['BookMarks']).unshift(({ 'Page': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('81a239a2700addf2bfccfca1ee432dff')))))),'Surah': ((___arguments.context.pageData['Selected'])['surah_name']),'Aya': ((___arguments.context.pageData['Selected'])['aya_number_ar']),'id': ((___arguments.context.pageData['Selected'])['objectId']),'Page-E': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('81a239a2700addf2bfccfca1ee432dff')) }));
    localStorage.setItem('BookMarks', JSON.stringify((___arguments.context.pageData['BookMarks'])));
  }

  },  
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      if ((___arguments.context.pageData['Selected']) !== null && !Array.isArray((___arguments.context.pageData['Selected'])) && (typeof (___arguments.context.pageData['Selected']) === 'object')) {
    return false;
  } else {
    return true;
  }

  },  
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/quran/components/f509e97e93416b87940d9043afd1cb3c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('الصفحة: ') + String(___arguments.context.getComponentDataStoreByUid('6fb2c25a01c6a0a724877e77912d08fb')['Page']))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/quran/components/37fc6f85b299857b7d51c5ca4f2d8da1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('السورة: ') + String(___arguments.context.getComponentDataStoreByUid('6fb2c25a01c6a0a724877e77912d08fb')['Surah']))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/quran/components/168afd097a9a39cb0d4dd8fb387e08e1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('الآيه: ') + String(___arguments.context.getComponentDataStoreByUid('6fb2c25a01c6a0a724877e77912d08fb')['Aya']))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/quran/components/373b9b062d7d56a38fd1b692623a069f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;


  ___arguments.context.pageData['BookMarks'] = (await (async () => {
    async function callback (item) {


      return ((item['id']) != (___arguments.context.getComponentDataStoreByUid('6fb2c25a01c6a0a724877e77912d08fb')['id']));
    }

    const list = await Promise.all((___arguments.context.pageData['BookMarks']).map(async source => ({
      source,
      value: await callback(source),
    })));

    const resultList = list.filter(item => item.value)

    return resultList.map(item => item.source)
  })());
  localStorage.setItem('BookMarks', JSON.stringify((___arguments.context.pageData['BookMarks'])));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/quran/components/7329595941e2a10d1dfbe39a81c80dac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if ((___arguments.context.pageData['Selected']) !== null && !Array.isArray((___arguments.context.pageData['Selected'])) && (typeof (___arguments.context.pageData['Selected']) === 'object')) {
    return true;
  } else {
    return false;
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/quran/components/c23cbb182f790de194d44aa4b59d6dd4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var aya, item, surah;


  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('81a239a2700addf2bfccfca1ee432dff', (___arguments.context.getComponentDataStoreByUid('6fb2c25a01c6a0a724877e77912d08fb')['Page-E']));
  await new Promise(r => setTimeout(r, 100 || 0));
  console.log(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')).pop());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ba088c7265f70b19b01bd70145e901a8', (await BackendlessUI.Functions.Custom['fn_a31967cfcdfc3278762b05fe92b4fc2f']((JSON.parse((___arguments.context.getComponentDataStoreByUid('6fb2c25a01c6a0a724877e77912d08fb')['Page-E']))), null)));
  surah = (await (async () => {
    async function callback (item) {


      return ((___arguments.context.getComponentDataStoreByUid('6fb2c25a01c6a0a724877e77912d08fb')['Surah']) == (item['surah_name']));
    }

    const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ba088c7265f70b19b01bd70145e901a8')).map(async source => ({
      source,
      value: await callback(source),
    })));

    const resultList = list.filter(item => item.value)

    return resultList.map(item => item.source)
  })())[0];
  if (surah !== null && !Array.isArray(surah) && (typeof surah === 'object')) {
    aya = (await (async () => {
      async function callback (item) {


        return ((___arguments.context.getComponentDataStoreByUid('6fb2c25a01c6a0a724877e77912d08fb')['id']) == (item['objectId']));
      }

      const list = await Promise.all((surah['aya']).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })())[0];
    aya['class'] = ['save'];
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/quran/components/27ab4dc54b0c0e71355572fd01e45491/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')).indexOf('toggled-right') !== -1) {
    return (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')).pop());
  } else {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')), 'toggled-right');
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/quran/components/759a164c0e6a7901ab4fa771053a76e4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')).indexOf('toggled-right') !== -1) {
    return (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')).pop());
  } else {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eefc645889e60163ce71ffeef0260489')), 'toggled-right');
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/search/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var buttonLogin, error, list, logging, password, search, stayLoggedIn, student;

/**
 * Describe this function...
 */
async function login() {
  try {
    student = (await Backendless.Data.of('Student').find(Backendless.DataQueryBuilder.create().setWhereClause((['national_id=\'',search,'\''].join(''))).setProperties(['objectId', 'name', 'sex']).setPageSize(1)));
    if (student.length == 1) {
      student = student[0];
    } else {
      await setError((new Error('لايوجد طالب بالسجل المدخل.')));
    }

  } catch (error) {
    await setError((new Error('حدث خطأ.')));

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
  student = null;
}

/**
 * Describe this function...
 */
async function updateButtonLogin(logging) {
  buttonLogin = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  buttonLogin['label'] = (logging ? 'الرجاء الإنتظار....' : 'بحث');
  buttonLogin['disabled'] = logging;
}


  await setError(null);
  search = (___arguments.context.dataModel['username']);
  if (search) {
    await updateButtonLogin(true);
    try {
      await login();

    } catch (error) {
      if ((error['code']) == 3033) {
        await login();
      } else {
        await setError(error);
      }

    } finally {
      await updateButtonLogin(false);

    }
  } else {
    await setError((new Error('لايوجد طالب بالسجل المدخل.')));
  }
  if (student) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('student_detail', ({ 'student': (student['objectId']),'name': (student['name']),'sex': (student['sex']) }));
  }

  },  
  /* handler:onSubmit *//* content */
}));

define('./pages/search/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      await Backendless.UserService.logout()

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/search/components/f8440789ca334b45ce69d2f5dfd3d906/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('dd5c653101c733a2cff71b650e6b215a'))['height'] = '0';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/search/components/116994740fa538677911ad55b1f1ff9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('dd5c653101c733a2cff71b650e6b215a'))['height'] = '100%';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/stat_all/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  onEnter(___arguments) {
      console.log('AppData');
  console.log(___arguments.context.appData);
  console.log('PageData');
  console.log(___arguments.context.pageData);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/stat_all/components/5641b07b2fdf4c1e5f09b15d7cf2aba9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var circles, item, j, monthDef, test, comps, student_test, students, teachers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', false);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['label'] = 'الرجاء الانتظار...';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['disabled'] = true;
  if ((new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9305df46bb86f11566662e3f17b384a8')), 'value')))) >= (new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('498ce4b163ab2b4b572dc3bfa6728dcd')), 'value'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', false);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('38b5b80e2bd918c6266ff92f963b6a75'))['content'] = 'فترة البحث غير صحيحة.';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['label'] = 'عرض بأستخدام التاريخ الثابت';
    throw (new Error('فترة البحث غير صحيحة.'))
  }
  if ('' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9305df46bb86f11566662e3f17b384a8')), 'value'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', false);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('38b5b80e2bd918c6266ff92f963b6a75'))['content'] = 'التاريخ من مطلوب';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['label'] = 'عرض بأستخدام التاريخ الثابت';
    throw (new Error('التاريخ من مطلوب'))
  }
  if ('' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('498ce4b163ab2b4b572dc3bfa6728dcd')), 'value'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', false);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('38b5b80e2bd918c6266ff92f963b6a75'))['content'] = 'التاريخ الى مطلوب';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['label'] = 'عرض بأستخدام التاريخ الثابت';
    throw (new Error('التاريخ الى مطلوب'))
  }
  monthDef = Math.round((((new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('498ce4b163ab2b4b572dc3bfa6728dcd')), 'value')))).valueOf()) - ((new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9305df46bb86f11566662e3f17b384a8')), 'value')))).valueOf())) / 2592000000);
  comps = (await Backendless.Data.of('page_completion').find(Backendless.DataQueryBuilder.create().setWhereClause((['per =100 and updated >= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9305df46bb86f11566662e3f17b384a8')), 'value')),'\' and updated <= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('498ce4b163ab2b4b572dc3bfa6728dcd')), 'value')),'\' AND student_link.NotActive =\'0\''].join(''))).setProperties(['Count(objectId) as pages', 'student_link.circle_link.comp[circle_link].name as name', 'student_link.circle_link.comp[circle_link].objectId as objectId']).setGroupBy('student_link.circle_link.comp[circle_link].objectId').setPageSize(100)));
  students = (await Backendless.Data.of('Student').find(Backendless.DataQueryBuilder.create().setWhereClause('NotActive is null OR NotActive=\'0\'').setProperties(['Count(objectId) as students', 'circle_link.comp[circle_link].objectId as objectId']).setGroupBy('circle_link.comp[circle_link].objectId').setPageSize(100)));
  circles = (await Backendless.Data.of('comp').find(Backendless.DataQueryBuilder.create().setProperties(['name', 'objectId', 'Count(circle_link) as circles']).setGroupBy('objectId').setPageSize(100)));
  teachers = (await Backendless.Data.of('circle').find(Backendless.DataQueryBuilder.create().setProperties(['Count(user_link) as teachers', 'comp[circle_link].objectId']).setGroupBy('comp[circle_link].objectId').setPageSize(100)));
  for (var j_index in circles) {
    j = circles[j_index];
    console.log(j);
    delete j['___class'];
    j['teachers'] = ((((await asyncListFilter(teachers, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0]) !== null && !Array.isArray(((await asyncListFilter(teachers, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0])) && (typeof ((await asyncListFilter(teachers, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0]) === 'object')) ? (getObjectProperty(((await asyncListFilter(teachers, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0]), 'teachers')) : 0);
    student_test = (await asyncListFilter(students, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0];
    j['students'] = ((student_test !== null && !Array.isArray(student_test) && (typeof student_test === 'object')) ? (getObjectProperty(student_test, 'students')) : 0);
    test = (await asyncListFilter(comps, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0];
    j['pages'] = ((test !== null && !Array.isArray(test) && (typeof test === 'object')) ? (getObjectProperty(test, 'pages')) : 0);
    if ((getObjectProperty(j, 'students')) != 0) {
      j['completion'] = (String(Math.round(100 * ((JSON.parse((getObjectProperty(j, 'pages')))) / ((JSON.parse((getObjectProperty(j, 'students')))) * monthDef * 6.5)))) + String('%'));
      delete j['objectId'];
    }
  }
  console.log('abc');
  circles = (await asyncListFilter(circles, async (item) => {


   return ((getObjectProperty(item, 'students')) != 0);
  }));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', true);
  await (async function(data) {

  	let myTable = document.querySelector('#table');
  	myTable.innerHTML="";
  	let employees = data;
  	let headers = ['المجمع/الدار','الحلق','المعلمين', 'الطلاب', 'عدد الأوجة','نسبة الإنجاز' ];
  	    let table = document.createElement('table');
  	    let headerRow = document.createElement('tr');
  	    headers.forEach(headerText => {
  	        let header = document.createElement('th');
  	        let textNode = document.createTextNode(headerText);
  	        header.appendChild(textNode);
  	        headerRow.appendChild(header);
  	    });
  	    table.appendChild(headerRow);
  	    employees.forEach(emp => {
  	        let row = document.createElement('tr');
  	        Object.values(emp).forEach(text => {
  	            let cell = document.createElement('td');
  	            let textNode = document.createTextNode(text);
  	            cell.appendChild(textNode);
  	            row.appendChild(cell);
  	        })
  	        table.appendChild(row);
  	    });
  	    myTable.appendChild(table);

  })(circles);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['disabled'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['label'] = 'عرض بأستخدام التاريخ الثابت';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/stat_all/components/556670056aeb7d11fee929986697b799/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	var data = [];
  		var rows = document.querySelectorAll("table tr");

  		for (var i = 0; i < rows.length; i++) {
  			var row = [], cols = rows[i].querySelectorAll("td, th");

  			for (var j = 0; j < cols.length; j++) {
  			        row.push(cols[j].innerText);
  	        }

  			data.push(row.join(","));
  		}


  	var html = document.querySelector("table").outerHTML;

  		csv_file = new Blob([data.join(`
  	`)], {type: "text/csv"});

  		download_link = document.createElement("a");

  		download_link.download = "result.csv";

  		download_link.href = window.URL.createObjectURL(csv_file);

  		download_link.style.display = "none";

  		document.body.appendChild(download_link);

  		download_link.click();
  		download_link.remove();

  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/stat_all/components/d3ca67c952a533ecd6b4f0db8b333c4d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('stat_comp', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/stat_all/components/1f4aebb525620ef845a8faa9c17ed119/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var circles, item, j, monthDef, test, comps, student_test, students, teachers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', false);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1f4aebb525620ef845a8faa9c17ed119'))['label'] = 'الرجاء الانتظار...';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1f4aebb525620ef845a8faa9c17ed119'))['disabled'] = true;
  if ((new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7731025c2d88ad2c35d49815ba84900e')), 'value')))) >= (new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8f15d22ea3f4331ab4d9bd4aa8314d05')), 'value'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', false);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('38b5b80e2bd918c6266ff92f963b6a75'))['content'] = 'فترة البحث غير صحيحة.';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1f4aebb525620ef845a8faa9c17ed119'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1f4aebb525620ef845a8faa9c17ed119'))['label'] = 'عرض بأستخدام التاريخ المرن';
    throw (new Error('فترة البحث غير صحيحة.'))
  }
  if (null == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7731025c2d88ad2c35d49815ba84900e')), 'value'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', false);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('38b5b80e2bd918c6266ff92f963b6a75'))['content'] = 'التاريخ من مطلوب';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1f4aebb525620ef845a8faa9c17ed119'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1f4aebb525620ef845a8faa9c17ed119'))['label'] = 'عرض بأستخدام التاريخ المرن';
    throw (new Error('التاريخ من مطلوب'))
  }
  if (null == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8f15d22ea3f4331ab4d9bd4aa8314d05')), 'value'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', false);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('38b5b80e2bd918c6266ff92f963b6a75'))['content'] = 'التاريخ الى مطلوب';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1f4aebb525620ef845a8faa9c17ed119'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1f4aebb525620ef845a8faa9c17ed119'))['label'] = 'عرض بأستخدام التاريخ المرن';
    throw (new Error('التاريخ الى مطلوب'))
  }
  monthDef = Math.round((((new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8f15d22ea3f4331ab4d9bd4aa8314d05')), 'value')))).valueOf()) - ((new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7731025c2d88ad2c35d49815ba84900e')), 'value')))).valueOf())) / 86417496);
  comps = (await Backendless.Data.of('page_completion').find(Backendless.DataQueryBuilder.create().setWhereClause((['per =100 and updated >= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7731025c2d88ad2c35d49815ba84900e')), 'value')),'\' and updated <= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8f15d22ea3f4331ab4d9bd4aa8314d05')), 'value')),'\' AND (student_link.NotActive is null OR student_link.NotActive=0)'].join(''))).setProperties(['Count(objectId) as pages', 'student_link.circle_link.comp[circle_link].name as name', 'student_link.circle_link.comp[circle_link].objectId as objectId']).setGroupBy('student_link.circle_link.comp[circle_link].objectId').setPageSize(100)));
  students = (await Backendless.Data.of('Student').find(Backendless.DataQueryBuilder.create().setWhereClause('NotActive is null OR NotActive=0').setProperties(['Count(objectId) as students', 'circle_link.comp[circle_link].objectId as objectId']).setGroupBy('circle_link.comp[circle_link].objectId').setPageSize(100)));
  circles = (await Backendless.Data.of('comp').find(Backendless.DataQueryBuilder.create().setWhereClause('Student[circle_link].NotActive is null OR Student[circle_link].NotActive=0').setProperties(['name', 'objectId', 'Count(circle_link) as circles']).setGroupBy('objectId').setPageSize(100)));
  teachers = (await Backendless.Data.of('circle').find(Backendless.DataQueryBuilder.create().setProperties(['Count(user_link) as teachers', 'comp[circle_link].objectId']).setGroupBy('comp[circle_link].objectId').setPageSize(100)));
  for (var j_index in circles) {
    j = circles[j_index];
    console.log(j);
    delete j['___class'];
    j['teachers'] = ((((await asyncListFilter(teachers, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0]) !== null && !Array.isArray(((await asyncListFilter(teachers, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0])) && (typeof ((await asyncListFilter(teachers, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0]) === 'object')) ? (getObjectProperty(((await asyncListFilter(teachers, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0]), 'teachers')) : 0);
    student_test = (await asyncListFilter(students, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0];
    j['students'] = ((student_test !== null && !Array.isArray(student_test) && (typeof student_test === 'object')) ? (getObjectProperty(student_test, 'students')) : 0);
    test = (await asyncListFilter(comps, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0];
    j['pages'] = ((test !== null && !Array.isArray(test) && (typeof test === 'object')) ? (getObjectProperty(test, 'pages')) : 0);
    if ((getObjectProperty(j, 'students')) != 0) {
      j['completion'] = (String(Math.round(100 * ((JSON.parse((getObjectProperty(j, 'pages')))) / ((JSON.parse((getObjectProperty(j, 'students')))) * monthDef * 0.33)))) + String('%'));
      delete j['objectId'];
    }
  }
  console.log('abc');
  circles = (await asyncListFilter(circles, async (item) => {


   return ((getObjectProperty(item, 'students')) != 0);
  }));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', true);
  await (async function(data) {

  	let myTable = document.querySelector('#table');
  	myTable.innerHTML="";
  	let employees = data;
  	let headers = ['المجمع/الدار','الحلق','المعلمين', 'الطلاب', 'عدد الأوجة','نسبة الإنجاز' ];
  	    let table = document.createElement('table');
  	    let headerRow = document.createElement('tr');
  	    headers.forEach(headerText => {
  	        let header = document.createElement('th');
  	        let textNode = document.createTextNode(headerText);
  	        header.appendChild(textNode);
  	        headerRow.appendChild(header);
  	    });
  	    table.appendChild(headerRow);
  	    employees.forEach(emp => {
  	        let row = document.createElement('tr');
  	        Object.values(emp).forEach(text => {
  	            let cell = document.createElement('td');
  	            let textNode = document.createTextNode(text);
  	            cell.appendChild(textNode);
  	            row.appendChild(cell);
  	        })
  	        table.appendChild(row);
  	    });
  	    myTable.appendChild(table);

  })(circles);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1f4aebb525620ef845a8faa9c17ed119'))['disabled'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1f4aebb525620ef845a8faa9c17ed119'))['label'] = 'عرض بأستخدام التاريخ المرن';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/stat_comp/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('fa5f0b0e96f952fbbcf9887218c7c909', (await Backendless.Data.of('comp').find(Backendless.DataQueryBuilder.create().setProperties(['name as label', 'objectId as value']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/stat_comp/components/5641b07b2fdf4c1e5f09b15d7cf2aba9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var monthDef, students, j, test, item, page_comletion, juza_test, juza, circles, student_test;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function for_circle() {
  page_comletion = (await Backendless.Data.of('page_completion').find(Backendless.DataQueryBuilder.create().setWhereClause((['per =100 and updated >= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9305df46bb86f11566662e3f17b384a8')), 'value')),'\' and updated <= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('498ce4b163ab2b4b572dc3bfa6728dcd')), 'value')),'\' AND student_link.circle_link.objectId=\'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')),'\''].join(''))).setProperties(['Count(objectId) as pages', 'student_link.objectId as objectId']).setGroupBy('student_link.objectId').setPageSize(100)));
  juza = (await Backendless.Data.of('juza_completion').find(Backendless.DataQueryBuilder.create().setWhereClause((['per =100 and updated >= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9305df46bb86f11566662e3f17b384a8')), 'value')),'\' and updated <= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('498ce4b163ab2b4b572dc3bfa6728dcd')), 'value')),'\' AND student_link.circle_link.objectId=\'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')),'\''].join(''))).setProperties(['Count(objectId) as juza', 'student_link.objectId as objectId']).setGroupBy('student_link.objectId').setPageSize(100)));
  students = (await Backendless.Data.of('Student').find(Backendless.DataQueryBuilder.create().setWhereClause((['circle_link.objectId=\'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')),'\' AND (NotActive = 0 or NotActive is null)'].join(''))).setProperties(['objectId', 'name']).setPageSize(100)));
  console.log(students);
  for (var j_index in students) {
    j = students[j_index];
    delete j['___class'];
    juza_test = (await asyncListFilter(juza, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0];
    j['juza'] = ((juza_test !== null && !Array.isArray(juza_test) && (typeof juza_test === 'object')) ? (getObjectProperty(juza_test, 'juza')) : 0);
    test = (await asyncListFilter(page_comletion, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0];
    j['pages'] = ((test !== null && !Array.isArray(test) && (typeof test === 'object')) ? (getObjectProperty(test, 'pages')) : 0);
    j['completion'] = (String(Math.round(100 * ((JSON.parse((getObjectProperty(j, 'pages')))) / ((JSON.parse('1')) * monthDef * 6.5)))) + String('%'));
    delete j['objectId'];
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', true);
  await (async function(data) {

  	let myTable = document.querySelector('#table');
  	myTable.innerHTML="";
  	let employees = data;
  	let headers = ['الطالب','عدد الأجزاء', 'عدد الأوجة','نسبة الإنجاز' ];
  	    let table = document.createElement('table');
  	    let headerRow = document.createElement('tr');
  	    headers.forEach(headerText => {
  	        let header = document.createElement('th');
  	        let textNode = document.createTextNode(headerText);
  	        header.appendChild(textNode);
  	        headerRow.appendChild(header);
  	    });
  	    table.appendChild(headerRow);
  	    employees.forEach(emp => {
  	        let row = document.createElement('tr');
  	        Object.values(emp).forEach(text => {
  	            let cell = document.createElement('td');
  	            let textNode = document.createTextNode(text);
  	            cell.appendChild(textNode);
  	            row.appendChild(cell);
  	        })
  	        table.appendChild(row);
  	    });
  	    myTable.appendChild(table);

  })(students);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['disabled'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['label'] = 'عرض';
}

/**
 * Describe this function...
 */
async function for_comp() {
  page_comletion = (await Backendless.Data.of('page_completion').find(Backendless.DataQueryBuilder.create().setWhereClause((['per =100 and updated >= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9305df46bb86f11566662e3f17b384a8')), 'value')),'\' and updated <= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('498ce4b163ab2b4b572dc3bfa6728dcd')), 'value')),'\' and student_link.circle_link.comp[circle_link].objectId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fa5f0b0e96f952fbbcf9887218c7c909')),((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')) == 'All' ? '\'' : ['\' AND  student_link.circle_link.objectId=\'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')),'\''].join('')].join(''))).setProperties(['Count(objectId) as pages', 'student_link.circle_link.name as name', 'student_link.circle_link.objectId as objectId']).setGroupBy('student_link.circle_link.objectId').setPageSize(100)));
  students = (await Backendless.Data.of('Student').find(Backendless.DataQueryBuilder.create().setWhereClause((['(NotActive = 0 or NotActive is null) and circle_link.comp[circle_link].objectId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fa5f0b0e96f952fbbcf9887218c7c909')),'\''].join(''))).setProperties(['Count(objectId) as students', 'circle_link.objectId as objectId']).setGroupBy('circle_link.objectId').setPageSize(100)));
  circles = (await Backendless.Data.of('circle').find(Backendless.DataQueryBuilder.create().setWhereClause((['comp[circle_link].objectId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fa5f0b0e96f952fbbcf9887218c7c909')),((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')) == 'All' ? '\'' : ['\' AND objectId=\'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')),'\''].join('')].join(''))).setProperties(['name', 'objectId', 'count(user_link) as teachers']).setGroupBy('objectId').setPageSize(100)));
  console.log(circles);
  for (var j_index2 in circles) {
    j = circles[j_index2];
    console.log(j);
    delete j['___class'];
    student_test = (await asyncListFilter(students, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0];
    j['students'] = ((student_test !== null && !Array.isArray(student_test) && (typeof student_test === 'object')) ? (getObjectProperty(student_test, 'students')) : 0);
    test = (await asyncListFilter(page_comletion, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0];
    j['pages'] = ((test !== null && !Array.isArray(test) && (typeof test === 'object')) ? (getObjectProperty(test, 'pages')) : 0);
    j['completion'] = (String(Math.round(100 * ((JSON.parse((getObjectProperty(j, 'pages')))) / ((JSON.parse((getObjectProperty(j, 'students')))) * monthDef * 6.5)))) + String('%'));
    delete j['objectId'];
  }
  console.log(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('fa5f0b0e96f952fbbcf9887218c7c909')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', true);
  await (async function(data) {

  	let myTable = document.querySelector('#table');
  	myTable.innerHTML="";
  	let employees = data;
  	let headers = ['الحلقة','المعلمين', 'الطلاب', 'عدد الأوجة','نسبة الإنجاز' ];
  	    let table = document.createElement('table');
  	    let headerRow = document.createElement('tr');
  	    headers.forEach(headerText => {
  	        let header = document.createElement('th');
  	        let textNode = document.createTextNode(headerText);
  	        header.appendChild(textNode);
  	        headerRow.appendChild(header);
  	    });
  	    table.appendChild(headerRow);
  	    employees.forEach(emp => {
  	        let row = document.createElement('tr');
  	        Object.values(emp).forEach(text => {
  	            let cell = document.createElement('td');
  	            let textNode = document.createTextNode(text);
  	            cell.appendChild(textNode);
  	            row.appendChild(cell);
  	        })
  	        table.appendChild(row);
  	    });
  	    myTable.appendChild(table);

  })(circles);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['disabled'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['label'] = 'عرض';
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', false);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['label'] = 'الرجاء الانتظار...';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['disabled'] = true;
  if ((new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9305df46bb86f11566662e3f17b384a8')), 'value')))) >= (new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('498ce4b163ab2b4b572dc3bfa6728dcd')), 'value'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', false);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('38b5b80e2bd918c6266ff92f963b6a75'))['content'] = 'فترة البحث غير صحيحة.';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['label'] = 'عرض بأستخدام التاريخ الثابت';
    throw (new Error('فترة البحث غير صحيحة.'))
  }
  if ('' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9305df46bb86f11566662e3f17b384a8')), 'value'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', false);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('38b5b80e2bd918c6266ff92f963b6a75'))['content'] = 'التاريخ من مطلوب';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['label'] = 'عرض بأستخدام التاريخ الثابت';
    throw (new Error('التاريخ من مطلوب'))
  }
  if ('' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('498ce4b163ab2b4b572dc3bfa6728dcd')), 'value'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', false);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('38b5b80e2bd918c6266ff92f963b6a75'))['content'] = 'التاريخ الى مطلوب';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5641b07b2fdf4c1e5f09b15d7cf2aba9'))['label'] = 'عرض بأستخدام التاريخ الثابت';
    throw (new Error('التاريخ الى مطلوب'))
  }
  monthDef = Math.round((((new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('498ce4b163ab2b4b572dc3bfa6728dcd')), 'value')))).valueOf()) - ((new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9305df46bb86f11566662e3f17b384a8')), 'value')))).valueOf())) / 2592000000);
  console.log(monthDef);
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')) == 'All') {
    await for_comp();
  } else {
    await for_circle();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/stat_comp/components/556670056aeb7d11fee929986697b799/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await (async function() {
  	var data = [];
  		var rows = document.querySelectorAll("table tr");

  		for (var i = 0; i < rows.length; i++) {
  			var row = [], cols = rows[i].querySelectorAll("td, th");

  			for (var j = 0; j < cols.length; j++) {
  			        row.push(cols[j].innerText);
  	        }

  			data.push(row.join(","));
  		}


  	var html = document.querySelector("table").outerHTML;

  		csv_file = new Blob([data.join(`\n`)], {type: "text/csv"});

  		download_link = document.createElement("a");

  		download_link.download = "result.csv";

  		download_link.href = window.URL.createObjectURL(csv_file);

  		download_link.style.display = "none";

  		document.body.appendChild(download_link);

  		download_link.click();
  		download_link.remove();

  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/stat_comp/components/d3ca67c952a533ecd6b4f0db8b333c4d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('stat_all', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/stat_comp/components/fa5f0b0e96f952fbbcf9887218c7c909/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var list;


  list = (await Backendless.Data.of('circle').find(Backendless.DataQueryBuilder.create().setWhereClause((['comp[circle_link].objectId=\'',___arguments.value,'\''].join(''))).setProperties(['objectId as value', 'name as label']).setPageSize(100)));
  list.unshift(({ 'label': 'جميع الحلق','value': 'All' }));
  ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('b42a2e9bb0a802f10998b6048d1602be', list);
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('b42a2e9bb0a802f10998b6048d1602be', 'All');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/stat_comp/components/f2a4fbe88beb70c385363e34a793a4bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var monthDef, students, j, test, item, page_comletion, juza_test, juza, circles, student_test;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function for_circle() {
  page_comletion = (await Backendless.Data.of('page_completion').find(Backendless.DataQueryBuilder.create().setWhereClause((['per =100 and updated >= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6704f7dcf3e2763994144eab71fdbe19')), 'value')),'\' and updated <= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('53ca5ddb7c92d71be222925f6b996632')), 'value')),'\' AND student_link.circle_link.objectId=\'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')),'\''].join(''))).setProperties(['Count(objectId) as pages', 'student_link.objectId as objectId']).setGroupBy('student_link.objectId').setPageSize(100)));
  juza = (await Backendless.Data.of('juza_completion').find(Backendless.DataQueryBuilder.create().setWhereClause((['per =100 and updated >= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6704f7dcf3e2763994144eab71fdbe19')), 'value')),'\' and updated <= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('53ca5ddb7c92d71be222925f6b996632')), 'value')),'\' AND student_link.circle_link.objectId=\'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')),'\''].join(''))).setProperties(['Count(objectId) as juza', 'student_link.objectId as objectId']).setGroupBy('student_link.objectId').setPageSize(100)));
  students = (await Backendless.Data.of('Student').find(Backendless.DataQueryBuilder.create().setWhereClause((['circle_link.objectId=\'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')),'\' AND (NotActive = 0 or NotActive is null)'].join(''))).setProperties(['objectId', 'name']).setPageSize(100)));
  console.log(students);
  for (var j_index in students) {
    j = students[j_index];
    delete j['___class'];
    juza_test = (await asyncListFilter(juza, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0];
    j['juza'] = ((juza_test !== null && !Array.isArray(juza_test) && (typeof juza_test === 'object')) ? (getObjectProperty(juza_test, 'juza')) : 0);
    test = (await asyncListFilter(page_comletion, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0];
    j['pages'] = ((test !== null && !Array.isArray(test) && (typeof test === 'object')) ? (getObjectProperty(test, 'pages')) : 0);
    j['completion'] = (String(Math.round(100 * ((JSON.parse((getObjectProperty(j, 'pages')))) / ((JSON.parse('1')) * monthDef * 0.333)))) + String('%'));
    delete j['objectId'];
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', true);
  await (async function(data) {

  	let myTable = document.querySelector('#table');
  	myTable.innerHTML="";
  	let employees = data;
  	let headers = ['الطالب','عدد الأجزاء', 'عدد الأوجة','نسبة الإنجاز' ];
  	    let table = document.createElement('table');
  	    let headerRow = document.createElement('tr');
  	    headers.forEach(headerText => {
  	        let header = document.createElement('th');
  	        let textNode = document.createTextNode(headerText);
  	        header.appendChild(textNode);
  	        headerRow.appendChild(header);
  	    });
  	    table.appendChild(headerRow);
  	    employees.forEach(emp => {
  	        let row = document.createElement('tr');
  	        Object.values(emp).forEach(text => {
  	            let cell = document.createElement('td');
  	            let textNode = document.createTextNode(text);
  	            cell.appendChild(textNode);
  	            row.appendChild(cell);
  	        })
  	        table.appendChild(row);
  	    });
  	    myTable.appendChild(table);

  })(students);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2a4fbe88beb70c385363e34a793a4bd'))['disabled'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2a4fbe88beb70c385363e34a793a4bd'))['label'] = 'عرض بأستخدام التاريخ المرن';
}

/**
 * Describe this function...
 */
async function for_comp() {
  page_comletion = (await Backendless.Data.of('page_completion').find(Backendless.DataQueryBuilder.create().setWhereClause((['per =100 and updated >= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6704f7dcf3e2763994144eab71fdbe19')), 'value')),'\' and updated <= \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('53ca5ddb7c92d71be222925f6b996632')), 'value')),'\' and student_link.circle_link.comp[circle_link].objectId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fa5f0b0e96f952fbbcf9887218c7c909')),((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')) == 'All' ? '\'' : ['\' AND  student_link.circle_link.objectId=\'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')),'\''].join('')].join(''))).setProperties(['Count(objectId) as pages', 'student_link.circle_link.name as name', 'student_link.circle_link.objectId as objectId']).setGroupBy('student_link.circle_link.objectId').setPageSize(100)));
  students = (await Backendless.Data.of('Student').find(Backendless.DataQueryBuilder.create().setWhereClause((['(NotActive = 0 or NotActive is null) and circle_link.comp[circle_link].objectId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fa5f0b0e96f952fbbcf9887218c7c909')),'\''].join(''))).setProperties(['Count(objectId) as students', 'circle_link.objectId as objectId']).setGroupBy('circle_link.objectId').setPageSize(100)));
  circles = (await Backendless.Data.of('circle').find(Backendless.DataQueryBuilder.create().setWhereClause((['comp[circle_link].objectId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fa5f0b0e96f952fbbcf9887218c7c909')),((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')) == 'All' ? '\'' : ['\' AND objectId=\'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')),'\''].join('')].join(''))).setProperties(['name', 'objectId', 'count(user_link) as teachers']).setGroupBy('objectId').setPageSize(100)));
  console.log(circles);
  for (var j_index2 in circles) {
    j = circles[j_index2];
    console.log(j);
    delete j['___class'];
    student_test = (await asyncListFilter(students, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0];
    j['students'] = ((student_test !== null && !Array.isArray(student_test) && (typeof student_test === 'object')) ? (getObjectProperty(student_test, 'students')) : 0);
    test = (await asyncListFilter(page_comletion, async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'objectId')));
    }))[0];
    j['pages'] = ((test !== null && !Array.isArray(test) && (typeof test === 'object')) ? (getObjectProperty(test, 'pages')) : 0);
    j['completion'] = (String(Math.round(100 * ((JSON.parse((getObjectProperty(j, 'pages')))) / ((JSON.parse((getObjectProperty(j, 'students')))) * monthDef * 0.33)))) + String('%'));
    delete j['objectId'];
  }
  console.log(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('fa5f0b0e96f952fbbcf9887218c7c909')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', true);
  await (async function(data) {

  	let myTable = document.querySelector('#table');
  	myTable.innerHTML="";
  	let employees = data;
  	let headers = ['الحلقة','المعلمين', 'الطلاب', 'عدد الأوجة','نسبة الإنجاز' ];
  	    let table = document.createElement('table');
  	    let headerRow = document.createElement('tr');
  	    headers.forEach(headerText => {
  	        let header = document.createElement('th');
  	        let textNode = document.createTextNode(headerText);
  	        header.appendChild(textNode);
  	        headerRow.appendChild(header);
  	    });
  	    table.appendChild(headerRow);
  	    employees.forEach(emp => {
  	        let row = document.createElement('tr');
  	        Object.values(emp).forEach(text => {
  	            let cell = document.createElement('td');
  	            let textNode = document.createTextNode(text);
  	            cell.appendChild(textNode);
  	            row.appendChild(cell);
  	        })
  	        table.appendChild(row);
  	    });
  	    myTable.appendChild(table);

  })(circles);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2a4fbe88beb70c385363e34a793a4bd'))['disabled'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2a4fbe88beb70c385363e34a793a4bd'))['label'] = 'عرض بأستخدام التاريخ المرن';
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', false);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2a4fbe88beb70c385363e34a793a4bd'))['label'] = 'الرجاء الانتظار...';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2a4fbe88beb70c385363e34a793a4bd'))['disabled'] = true;
  if ((new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6704f7dcf3e2763994144eab71fdbe19')), 'value')))) >= (new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('53ca5ddb7c92d71be222925f6b996632')), 'value'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', false);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('38b5b80e2bd918c6266ff92f963b6a75'))['content'] = 'فترة البحث غير صحيحة.';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2a4fbe88beb70c385363e34a793a4bd'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2a4fbe88beb70c385363e34a793a4bd'))['label'] = 'عرض بأستخدام التاريخ المرن';
    throw (new Error('فترة البحث غير صحيحة.'))
  }
  if ('' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6704f7dcf3e2763994144eab71fdbe19')), 'value'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', false);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('38b5b80e2bd918c6266ff92f963b6a75'))['content'] = 'التاريخ من مطلوب';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2a4fbe88beb70c385363e34a793a4bd'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2a4fbe88beb70c385363e34a793a4bd'))['label'] = 'عرض بأستخدام التاريخ المرن';
    throw (new Error('التاريخ من مطلوب'))
  }
  if ('' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('53ca5ddb7c92d71be222925f6b996632')), 'value'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('38b5b80e2bd918c6266ff92f963b6a75', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ce087f992278bf82843c4b9ff47f19', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('556670056aeb7d11fee929986697b799', false);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('38b5b80e2bd918c6266ff92f963b6a75'))['content'] = 'التاريخ الى مطلوب';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2a4fbe88beb70c385363e34a793a4bd'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2a4fbe88beb70c385363e34a793a4bd'))['label'] = 'عرض بأستخدام التاريخ المرن';
    throw (new Error('التاريخ الى مطلوب'))
  }
  monthDef = Math.round((((new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('53ca5ddb7c92d71be222925f6b996632')), 'value')))).valueOf()) - ((new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6704f7dcf3e2763994144eab71fdbe19')), 'value')))).valueOf())) / 86417496);
  console.log(monthDef);
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b42a2e9bb0a802f10998b6048d1602be')) == 'All') {
    await for_comp();
  } else {
    await for_circle();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/student-R/components/69c2cd045e3a4aa9a56bf5e345286983/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	var data = [];
  		var rows = document.querySelectorAll("table tr");

  		for (var i = 0; i < rows.length; i++) {
  			var row = [], cols = rows[i].querySelectorAll("td, th");

  			for (var j = 0; j < cols.length; j++) {
  			        row.push(cols[j].innerText);
  	        }

  			data.push(row.join(","));
  		}


  	var html = document.querySelector("table").outerHTML;

  		csv_file = new Blob([data.join(`
  	`)], {type: "text/csv"});

  		download_link = document.createElement("a");

  		download_link.download = "result.csv";

  		download_link.href = window.URL.createObjectURL(csv_file);

  		download_link.style.display = "none";

  		document.body.appendChild(download_link);

  		download_link.click();
  		download_link.remove();

  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/student_detail/components/e352901a4747d17fcf57c288809c1f4e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('juza_completion').find(Backendless.DataQueryBuilder.create().setWhereClause((['student_link.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'student')),'\' AND updated > ',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))).setProperties(['per', 'juza_link.name']).setSortBy(['juza_link.juza_id ']).setPageSize(100)))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/student_detail/components/4f22737d1387d729a1ec290d4a589708/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [({ 'surah': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((await Backendless.Data.of('surah_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['per=100 and student_link.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'student')),'\' AND updated >',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))))))))),'page': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((await Backendless.Data.of('page_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['per=100 and student_link.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'student')),'\' AND updated >',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))))))))),'juza': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((await Backendless.Data.of('juza_completion').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['per=100 and student_link.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'student')),'\' AND updated >',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))))))))) })]

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/student_detail/components/b546d226b48b103a697dc1b4d161d9f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var ayat_total;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ayat_total = (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['ForStudent.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'student')),'\' AND created > ',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))).setProperties(['sum (AyaLink.letters_count) as letters_count', 'sum (AyaLink.words_count) as words_count', 'count (AyaLink) as aya_count']).setPageSize(1)))[0];
  return [({ 'letter': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(ayat_total, 'letters_count'))))))),'word': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(ayat_total, 'words_count'))))))),'aya': (await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((await Backendless.Request.post(`${Backendless.appPath}/services/numeral/numeralMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(ayat_total, 'aya_count'))))))) })];

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/student_detail/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['zeroTime'] = '\'08/20/2024\'';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/student_detail/components/da2811e3a8677e2d8a67bc59d90ae9a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('475480bedda872fdf245d91e057ceb74'))['height'] = '0';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/student_detail/components/69078f154dd6aaae3003b55b13fb8062/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('475480bedda872fdf245d91e057ceb74'))['height'] = '100%';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/student_detail/components/58ad5ab3a9224b26817e0246208d07a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return (String(' % ') + String(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['per']))))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/student_detail/components/55db3c97647ce09ae638f292510a414d/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (100 == (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['per'])) {
    return ['meter_bg_green'];
  } else {
    return ['meter_bg_orange'];
  }

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/student_detail/components/ca1d5c6d958b8c7bcc89df658dd68fe8/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (100 == (___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['per'])) {
    return ['meter'];
  } else {
    return ['meter', 'orange'];
  }

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/student_detail/components/5302910d5d79c58bd115a2fe69fc12e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('SavingRecords').find(Backendless.DataQueryBuilder.create().setWhereClause((['ForStudent.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'student')),'\' AND created > ',(getObjectProperty(___arguments.context.pageData, 'zeroTime'))].join(''))).setProperties(['ayat_total', 'created']).setSortBy('created desc').setPageSize(4)))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/student_detail/components/f10900694fba66e6d943da23bb5751be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return (['بنين' == (___arguments.context.pageData['sex']) ? 'اتم حفظ ' : 'اتمت حفظ ',(await BackendlessUI.Functions.Custom['fn_e0a989849d6a5d22cb686c19de15e3b5']((JSON.stringify((___arguments.context.getComponentDataStoreByUid('a58614058774369d925c599c6d948bdd')['ayat_total']))))),' ايات.'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/student_detail/components/c328f6f848ad05ee78279ff7e627c981/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ((___arguments.context.pageData['sex']) == 'بنين' ? String('الطالب ') + String(___arguments.context.pageData['name']) : String('الطالبه ') + String(___arguments.context.pageData['name']))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/student_detail/components/272f75f2028106668fa505712bc5b45d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return (await Backendless.Request.post(`${Backendless.appPath}/services/numeral/momentSinceMethod`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send(JSON.stringify((___arguments.context.getComponentDataStoreByUid('a58614058774369d925c599c6d948bdd')['created']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/student_detail/components/74b2437db80e20f6a7c2cfa3fc5c463d/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('74b2437db80e20f6a7c2cfa3fc5c463d'))['width'] = (String(___arguments.context.getComponentDataStoreByUid('2fd91bc6c2d7d49695f7dc5801c32647')['per']) + String('%'));

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/test/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  onEnter(___arguments) {
    var message;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function getRTSubscriptions() { const subs = getGlobalEntitiesMap('subscriptions');subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`RT subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}



  ;(function() {
    const callback = async message => {
        console.log(message);

    };

    const channel = getChannelInstance('default');

    const selector = '';
    const options = [callback];

    if (selector) {
       options.unshift(selector);
    }

    channel.addMessageListener.apply(channel, options);

    getRTSubscriptions().add('RT', () => channel.removeMessageListener.apply(channel, options));
  })()

  },  
  /* handler:onEnter */
  /* handler:onLeave */
  onLeave(___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getRTSubscriptions() { const subs = getGlobalEntitiesMap('subscriptions');subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`RT subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}


  getRTSubscriptions().remove('RT');;

  },  
  /* handler:onLeave */
  /* content */
}))

